/*
 * aa-moon-studio.js — GC28 v2 (Fable) — ergonomie PORTEFEUILLE (retour fondateur 19/07)
 * Studio LAMPE LUNE inline : TOUS les outils vivent SUR le stage (icônes-coins + popups +
 * overlays), zéro scroll pour créer. Colonne droite = titre/prix/déroulants/CTA/jauge.
 * Outils : 📷 photo · 🔍 cadrage (disque, drag/pinch/molette, rotation, Avant/Après) ·
 * ☀️ luminosité · 🧽 gomme magique (annuler ×20) · 🖼️ fond (plein/doux/ovale) · ✍️ texte verso.
 * Aperçu 3D Three.js + repli 2D (aa-moon-3d.js) ; doctrine VERBATIM : _aa_photo = renderReference
 * (recadrage + gravure + gomme + fond) = EXACTEMENT ce que montre l'aperçu.
 * L8 : les outils sont des éléments HORS du canvas 3D (jamais avalés par sa capture de pointeur).
 */
(function () {
  'use strict';
  var CFG = window.AA_MOON_CFG;
  /* Fond de contrôle des apercus d'edition. La reference est desormais TRANSPARENTE la ou le
     sujet a ete enleve (detourage ou gomme) ; sur le blanc du CSS, le client ne verrait aucune
     difference entre « enleve » et « blanc ». On peint donc dessous le niveau reel de la lune
     nue allumee — mesure a ~52/255 d'albedo, teinte par la LED chaude. Ce qu'il efface prend
     cette couleur : c'est exactement ce qu'il verra sur la lampe. L'apercu ne ment pas. */
  var FOND_LUNE = '#342c21';
  if (!CFG) { console.warn('[aa-moon] AA_MOON_CFG absent'); return; }
  var M = window.AAMoon;
  if (!M) { console.warn('[aa-moon] moteur AAMoon absent'); return; }

  var SID = CFG.sectionId, BASE = CFG.assetBase, VMAP = CFG.variantMap || {};
  var L = CFG.labels || {};
  var T = function (k, fr) { return L[k] || fr; };
  var byId = function (n) { return document.getElementById(n + '-' + SID); };
  var form = CFG.formId ? document.getElementById(CFG.formId) : null;
  var addBtn = function () { return form && form.querySelector('[name="add"]'); };
  var isMobileView = function () { return window.matchMedia('(max-width: 749px)').matches; };

  var COLORS16 = ['#ffd9a0', '#f2f6ff', '#ff6a5e', '#ff9d5c', '#ffc35e', '#ffe98a', '#c8f27a', '#7ee08a', '#6fe3c0', '#66d9e8', '#7cc0ff', '#6f8dff', '#9d7bff', '#c06fff', '#f06fd8', '#ff8fb1'];
  var COLORS3 = ['#ffd9a0', '#f2f6ff', '#ffe98a'];
  var COLORS2 = ['#ffd9a0', '#f2f6ff'];
  var COLOR_NAMES = { '#ffd9a0': 'Blanc chaud', '#f2f6ff': 'Blanc froid', '#ff6a5e': 'Corail', '#ff9d5c': 'Orange', '#ffc35e': 'Ambre', '#ffe98a': 'Jaune', '#c8f27a': 'Vert anis', '#7ee08a': 'Vert', '#6fe3c0': 'Menthe', '#66d9e8': 'Turquoise', '#7cc0ff': 'Bleu ciel', '#6f8dff': 'Bleu', '#9d7bff': 'Violet', '#c06fff': 'Pourpre', '#f06fd8': 'Magenta', '#ff8fb1': 'Rose' };
  function paletteFor(mode) {
    var m = (mode || '').toLowerCase();
    if (m.indexOf('16') >= 0) return COLORS16;
    if (m.indexOf('3') >= 0) return COLORS3;
    return COLORS2;
  }

  // ── État studio ──
  var st = {
    photo: null,
    photoOrig: null,           // photo telle que le client l'a envoyee — jamais ecrasee
    photoCut: null,            // meme photo, fond nettoye par fal.ai (null tant qu'absent)
    cut: false,                // laquelle des deux est actuellement gravee
    cutJeton: 0,               // anti-collision : une reponse tardive ne doit pas ecraser une NOUVELLE photo
    cutEnCours: false,         // un appel payant est en vol
    cutAnim: false,            // la dissolution est en cours (ne pas repeindre par-dessus)
    crop: { cx: 0.5, cy: 0.5, zoom: 1, rot: 0 },
    bright: 1.0,
    fond: 'ovale',              // 'plein' | 'doux' | 'ovale' — medaillon par defaut (reference fondateur 07/09/2026)
    strokes: [],                // gomme magique : groupes de coups (annuler = pop)
    gommeArmee: false,          // la gomme ne peint QUE si le client l'a armee (voir le bloc GOMME)
    text: '',
    lit: true, color: '#ffd9a0',
    face: 'front',
    ref: null,                  // référence gravée (VÉRITÉ transmise)
    albedo: null, dispImg: null, albedoKO: false,
    gl: null, mode: 'boot',
    uid: null,
    touched: { cadrage: false, reglages: false },
    /* Gravure en dessin : photoDessin est garde en memoire, donc basculer dessin <-> photo est
       GRATUIT et instantane. Seule une nouvelle demande coute, et elle est plafonnee. */
    photoDessin: null, dessin: false, dessinEnCours: false, dessinRelances: 0,
    fondChoisi: false           // le client a touche au Fond : on ne le change plus a sa place
  };
  var DESSIN_RELANCES_MAX = 2;   // 1 essai + 2 relances = 0,12 $ au pire par client
  /* LE DESSIN EST REDEVENU LE CHEMIN PRINCIPAL — decision fondateur 08/09/2026.
     Le 07/09 il l'avait sorti du rail (« garde en option cachee le dessin pour le moment »).
     Le 08/09 il a tranche l'inverse, sur un argument que la photo ne peut pas resoudre :
     « imaginons une personne noire, elle ne verrait pas les traits de son visage — or avec un
     dessin cela corrige le tout ». Une photo encode de la LUMINOSITE : sur une peau foncee,
     tout le visage tombe dans la meme valeur et devient une masse. Un dessin encode des
     CONTOURS, qui restent lisibles quelle que soit la carnation.
     Le parametre ?aa-dessin=1 n'a donc plus de raison d'etre : le crayon est toujours la. */

  // ── Fix layout + stage injecté colonne média ──
  var productWrap = document.querySelector('.product.product--no-media') || document.querySelector('.product');
  if (productWrap && productWrap.classList.contains('product--no-media')) { productWrap.classList.remove('product--no-media'); productWrap.classList.add('grid--2-col-tablet'); }

  var stage = document.createElement('div'); stage.className = 'aa-moon-stage';
  /* Style du declencheur, injecte ici plutot que dans le snippet : tout le studio construit
     deja son DOM depuis ce fichier, et ca evite un push de theme supplementaire. */
  (function styleCut() {
    if (document.getElementById('aa-moon-cut-css')) return;
    var st2 = document.createElement('style');
    st2.id = 'aa-moon-cut-css';
    st2.textContent =
      '.aa-ov-cut{width:min(320px,92%);padding:11px 16px;border:1px solid rgba(255,233,196,.55);' +
      'border-radius:999px;background:rgba(201,160,90,.18);color:#ffe9c4;font:700 12.5px system-ui;' +
      'cursor:pointer;transition:background .18s,border-color .18s,opacity .18s}' +
      '.aa-ov-cut:hover{background:rgba(201,160,90,.34);border-color:#ffe9c4}' +
      '.aa-ov-cut[disabled]{opacity:.55;cursor:progress}' +
      /* Le dessin est l'action VEDETTE : plein or, au-dessus du detourage qui reste secondaire. */
      '.aa-ov-dessin{width:min(320px,92%);padding:12px 16px;border:none;border-radius:999px;' +
      'background:#c9a05a;color:#1c1610;font:700 13px system-ui;cursor:pointer;' +
      'box-shadow:0 6px 18px rgba(201,160,90,.38);transition:filter .18s,opacity .18s}' +
      '.aa-ov-dessin:hover{filter:brightness(1.08)}' +
      '.aa-ov-dessin[disabled]{opacity:.55;cursor:progress;box-shadow:none}' +
      '.aa-ov-relance{margin-top:2px;padding:4px 8px;border:none;background:transparent;' +
      'color:#d9c8a4;font:600 11.5px system-ui;cursor:pointer;text-decoration:underline}' +
      '.aa-ov-relance[disabled]{opacity:.5;cursor:default;text-decoration:none}' +
      /* Croix de fermeture — meme place sur TOUS les panneaux (retour fondateur 07/09/2026) */
      '.aa-panneau-x{position:absolute;top:8px;right:10px;z-index:9;width:32px;height:32px;' +
      'padding:0;border:1px solid rgba(255,255,255,.3);border-radius:50%;background:rgba(16,19,30,.82);' +
      'color:#ffe9c4;font:600 15px/1 system-ui;cursor:pointer;display:flex;align-items:center;' +
      'justify-content:center;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}' +
      '.aa-panneau-x:hover{background:rgba(201,160,90,.36);border-color:#ffe9c4}' +
      /* Bouton d'armement de la gomme : discret desarme, franchement allume une fois arme —
         le client doit voir d'un coup d'oeil si son doigt va effacer ou faire defiler. */
      '.aa-ov-armer{flex:1 1 auto;padding:8px 14px;border-radius:999px;cursor:pointer;font:600 12px system-ui;' +
      'white-space:nowrap;border:1px solid rgba(255,233,196,.45);background:rgba(255,255,255,.07);color:#ffe9c4}' +
      /* Dans le tiroir Fond, « Annuler » partage la ligne avec la gomme : il ne se casse pas en deux. */
      '.aa-moon-ov .aa-ov-undo{flex:0 0 auto;white-space:nowrap}' +
      '.aa-ov-armer.active{background:linear-gradient(135deg,#e6b866,#c9a05a);color:#231a10;' +
      'border-color:#ffe9c4;box-shadow:0 0 0 3px rgba(201,160,90,.28)}' +
      '.aa-ov-erase.armee{box-shadow:0 0 0 2px #e6b866,0 6px 22px rgba(0,0,0,.5)}' +
      /* « Tout afficher » — le raccourci qui pose le zoom exact pour que la photo entiere tienne
         dans le cadrage. Depuis le 15/09 c'est une ICONE en bout du curseur de zoom (le tiroir
         s'epure, retour fondateur) ; le mot reste dans aria-label/title. */
      '.aa-ov-tout{flex:0 0 auto;width:30px;height:30px;padding:0;border-radius:50%;' +
      'cursor:pointer;font:600 15px/1 system-ui;border:1px solid rgba(255,233,196,.45);' +
      'background:rgba(255,255,255,.07);color:#ffe9c4;display:inline-flex;align-items:center;justify-content:center}' +
      '.aa-ov-tout:hover{background:rgba(201,160,90,.28);border-color:#ffe9c4}' +
      /* Options de fond, desormais DANS le tiroir Fond (ex-popup) : trois pilules sur une ligne. */
      '.aa-moon-ov .aa-fond-opts{width:min(320px,92%);display:flex;gap:7px}' +
      '.aa-moon-ov .aa-fond-opts button{flex:1;padding:8px 4px;border:1.5px solid rgba(255,255,255,.3);' +
      'border-radius:10px;background:transparent;color:#f2ead8;font:600 12px system-ui;cursor:pointer}' +
      '.aa-moon-ov .aa-fond-opts button.active{border-color:#ffe9c4;background:rgba(201,160,90,.28);color:#ffe9c4}' +
      /* ⏻ ICONE SEULE (retour fondateur 15/09 : le mot mangeait le hint). L'etat se lit a la
         couleur : OR = allumee, GRIS = eteinte ; le mot vit dans aria-label/title. */
      '.aa-moon-light svg,.aa-mfa svg{width:21px;height:21px;display:block}' +
      '.aa-moon-light[aria-pressed="true"]{color:#ffe9c4;border-color:rgba(255,233,196,.7);' +
      'background:rgba(201,160,90,.3);box-shadow:0 0 14px rgba(255,200,110,.45)}' +
      '.aa-moon-light[aria-pressed="false"]{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.25);' +
      'background:rgba(20,24,40,.5);box-shadow:none}' +
      /* Alerte de nettete. Elle PREVIENT, elle ne bloque pas : le client reste maitre de son
         cadrage. Elle apparait au moment ou il cree le probleme, pas dix minutes avant. */
      '.aa-ov-net{margin:2px auto 0;max-width:320px;padding:7px 12px;border-radius:10px;' +
      'font:600 12px/1.45 system-ui;text-align:center;color:#3a2a10;' +
      'background:rgba(255,205,120,.92);border:1px solid rgba(255,233,196,.7)}' +
      /* LE VOILE EN OR, SUR LA LUNE. Deux couches posees par-dessus la sphere :
           .aa-moon-voile-av — une PHOTO de la lune AVANT gravure, qui se retire du haut vers
             le bas (`clip-path`) ; ce qui apparait dessous, c'est la lune deja gravee ;
           .aa-moon-voile-or — la ligne d'or de 6 px qui descend sur le front d'onde.
         Les deux animations ne touchent que `clip-path` et `transform`, sur une image FIGEE :
         aucune texture n'est reconstruite pendant le balayage. Le rebuild (105 ms) se paie
         UNE fois, derriere le calque, pendant que le rideau est ferme. */
      '.aa-moon-voile{position:absolute;inset:0;z-index:5;pointer-events:none;overflow:hidden}' +
      '.aa-moon-voile[hidden]{display:none}' +
      '.aa-moon-voile-av{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;' +
      'clip-path:inset(0 0 0 0);will-change:clip-path}' +
      '.aa-moon-voile-or{position:absolute;left:0;right:0;top:-3px;height:6px;will-change:transform;' +
      'background:linear-gradient(90deg,rgba(255,217,138,0) 0%,rgba(255,243,214,1) 50%,' +
      'rgba(255,217,138,0) 100%);box-shadow:0 0 26px 6px rgba(255,190,90,.9)}' +
      /* La course de la ligne est donnee en PIXELS (--aa-front), mesuree sur le wrap au moment
         de la revelation. Un `translateY(100%)` se serait rapporte a la hauteur de la LIGNE
         elle-meme (6 px) — et surtout, toute hauteur en pourcentage tombe a zero des que le
         conteneur se replie. Une longueur absolue ne peut pas se derober. */
      '.aa-moon-voile.court .aa-moon-voile-av{animation:aa-voile-retrait 1700ms linear forwards}' +
      '.aa-moon-voile.court .aa-moon-voile-or{animation:aa-voile-front 1700ms linear forwards}' +
      '@keyframes aa-voile-retrait{from{clip-path:inset(0 0 0 0)}to{clip-path:inset(100% 0 0 0)}}' +
      '@keyframes aa-voile-front{from{transform:translateY(0)}to{transform:translateY(var(--aa-front,0px))}}' +
      '@media (prefers-reduced-motion:reduce){.aa-moon-voile.court .aa-moon-voile-av,' +
      '.aa-moon-voile.court .aa-moon-voile-or{animation-duration:1ms}}' +
      '.aa-moon-pop b{padding-right:36px}';
    document.head.appendChild(st2);
  })();

  stage.innerHTML =
    '<div class="aa-moon-room"></div>' +
    '<div class="aa-moon-wrap"><canvas class="aa-moon-cv2d" width="640" height="640"></canvas></div>' +
    /* ⏻ en SVG : le caractere U+23FB manque dans plusieurs polices Android (carre barre, capture
       fondateur 17/09). Un SVG en ligne se dessine partout, sans police. Meme traitement pour
       telecharger / partager, qui etaient des emojis (rendu different selon le telephone). */
    '<button type="button" class="aa-moon-light" aria-pressed="true" aria-label="' + T('turnOff', 'Éteindre') + '" title="' + T('turnOff', 'Éteindre') + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3v9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="M6.6 6.6a7.6 7.6 0 1 0 10.8 0" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
    '<div class="aa-moon-hint">' + T('hintSpin', '🌙 Faites tourner la lune du doigt') + '</div>' +
    '<div class="aa-moon-colors" role="group" aria-label="' + T('ledColors', 'Couleur de la lumière') + '"></div>' +
    /* Barre d'outils EN BAS de la carte (retour fondateur 15/09 : le rail vertical a gauche
       « faisait tache » ; en bas il tombe sous le pouce). Cinq outils au lieu de sept :
       la Lumiere vit dans le tiroir Cadrage, la Gomme et le detourage dans le tiroir Fond. */
    '<div class="aa-moon-rail" role="toolbar" aria-label="' + T('tools', 'Personnalisation') + '">' +
      '<button type="button" class="aa-mt" data-tool="photo" aria-label="' + T('tPhoto', 'Photo') + '"><span>📷</span><em>' + T('tPhoto', 'Photo') + '</em></button>' +
      '<button type="button" class="aa-mt" data-tool="cadrage" aria-label="' + T('tCadrage', 'Cadrage') + '"><span>🔍</span><em>' + T('tCadrage', 'Cadrage') + '</em></button>' +
      '<button type="button" class="aa-mt" data-tool="dessin" aria-label="' + T('tDessin', 'Transformer en dessin gravé') + '"><span>✏️</span><em>' + T('tDessin', 'Dessin') + '</em></button>' +
      '<button type="button" class="aa-mt" data-tool="fond" aria-label="' + T('tFond', 'Fond de la photo') + '"><span>🖼️</span><em>' + T('tFond', 'Fond') + '</em></button>' +
      '<button type="button" class="aa-mt" data-tool="texte" aria-label="' + T('tTexte', 'Texte au dos') + '"><span>✍️</span><em>' + T('tTexte', 'Texte') + '</em></button>' +
    '</div>' +
    // Actions du cadre (bas-droite) — partage / téléchargement (pattern portefeuille)
    /* DEUX APPAREILS PHOTO = DEUX FAUX AMIS (retour fondateur 07/09/2026). Le rail a deja un
       📷 « Photo » qui ajoute la photo ; ce 📸-la partageait, et le client croyait pouvoir
       ajouter sa photo par le mauvais bouton. Trois corrections :
         - 📸 devient 🔗 (partager un lien) — surtout PAS ⬆️/📤, qui relit « envoyer une photo » ;
         - les deux boutons n'existent qu'une fois la photo posee : rien a partager avant ;
         - le partage n'apparait que si le navigateur sait partager un fichier, sinon il
           dupliquait silencieusement le telechargement. */
    /* Colonne de droite (17/09) : ⏻ en haut, un cran vide, puis telecharger, puis partager —
       trois icones alignees, meme taille. ⏻ vit hors de ce conteneur parce que celui-ci n'existe
       qu'une fois la photo posee. Icones = standards du marche : fleche dans son bac, fleche courbe. */
    '<div class="aa-moon-frame-actions" hidden>' +
      '<button type="button" class="aa-mfa" data-act="dl" aria-label="' + T('dl', 'Télécharger l’aperçu') + '" title="' + T('dl', 'Télécharger l’aperçu') + '"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3v12M7 10.5l5 5 5-5M4 16.5V20h16v-3.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="aa-mfa" data-act="share" aria-label="' + T('share', 'Partager ma lune') + '" title="' + T('share', 'Partager ma lune') + '" hidden><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13.5 5.5 20 11l-6.5 5.5V13c-4.4 0-7.6 1.6-10 5 .9-4.9 3.9-8.8 10-9.5V5.5z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg></button>' +
    '</div>' +
    // Popup ✍️ texte
    '<div class="aa-moon-pop" data-pop="texte" hidden><b>' + T('tTexte', 'Texte au dos — offert') + '</b>' +
      '<div class="aa-pop-textrow"><input type="text" maxlength="40" class="aa-pop-text" placeholder="Léna · 14 février 2026" aria-label="' + T('tTexte', 'Texte gravé au dos') + '">' +
      '<button type="button" class="aa-pop-textoff" aria-label="' + T('tTexteOff', 'Retirer le texte') + '" title="' + T('tTexteOff', 'Retirer le texte') + '">🗑</button></div></div>' +
    // Overlay 🔍 CADRAGE (plein stage)
    '<div class="aa-moon-ov" data-ov="cadrage" hidden>' +
      '<canvas class="aa-ov-crop" width="300" height="300"></canvas>' +
      '<div class="aa-ov-ctrls">' +
        // min="45" : le client peut DEZOOMER. A 100 la fenetre valait le plus grand carre tenant
        // dans la photo — sur une 3:4 il en perdait deja 25 % sans pouvoir rien y faire.
        // min="15" : le plancher du portefeuille. Un client dont la photo de visage est trop
        // serree doit pouvoir reculer autant qu'il veut — c'est sa gravure qui en depend.
        '<label>' + T('zoom', 'Zoom') + '<input type="range" min="15" max="300" value="100" class="aa-ov-zoom">' +
          '<button type="button" class="aa-ov-tout" aria-label="' + T('toutAfficher', 'Tout afficher').replace(/^⤢\s*/, '') + '" title="' + T('toutAfficher', 'Tout afficher').replace(/^⤢\s*/, '') + '">⤢</button></label>' +
        '<div class="aa-ov-net" hidden></div>' +
        '<label>' + T('rot', 'Rotation') + '<input type="range" min="-90" max="90" value="0" class="aa-ov-rot"></label>' +
        /* La luminosite a quitte son popup ☀️ pour vivre ici : c'est un reglage de la photo,
           au meme titre que le zoom et la rotation (retour fondateur 15/09). Le curseur
           Avant/Apres, qui n'etait qu'un apercu jamais grave, est retire. */
        '<label>' + T('tLum', 'Lumière') + '<input type="range" min="70" max="150" value="100" class="aa-ov-bright"></label>' +
      '</div>' +
      '<button type="button" class="aa-ov-ok">' + T('ok', '✓ Valider') + '</button>' +
    '</div>' +
    /* Overlay 🖼️ FOND (plein stage) — 15/09 : un seul tiroir pour tout ce qui touche au decor
       de la photo. Les trois fonds (ex-popup), le detourage IA et la gomme partagent la meme
       intention : decider ce qui entoure le visage. Le client ne cherche plus entre deux outils. */
    '<div class="aa-moon-ov" data-ov="fond" hidden>' +
      '<canvas class="aa-ov-erase" width="300" height="300"></canvas>' +
      '<div class="aa-fond-opts">' +
        '<button type="button" data-fond="plein">' + T('fPlein', 'Plein') + '</button>' +
        '<button type="button" data-fond="doux">' + T('fDoux', 'Fondu doux') + '</button>' +
        '<button type="button" data-fond="ovale" class="active">' + T('fOvale', 'Médaillon') + '</button>' +
      '</div>' +
      '<button type="button" class="aa-ov-cut">' + T('cutGo', '✨ Enlever l’arrière-plan') + '</button>' +
      // La gomme s'ARME — elle ne peint jamais d'elle-meme (retour fondateur 08/09/2026).
      '<div class="aa-ov-ctrls aa-ov-ctrls-row">' +
        '<button type="button" class="aa-ov-armer">' + T('gommeOn', '🧽 Activer la gomme') + '</button>' +
        '<button type="button" class="aa-ov-undo">↩︎ ' + T('undo', 'Annuler') + '</button>' +
      '</div>' +
      '<button type="button" class="aa-ov-ok">' + T('valider', '✓ Valider ma photo') + '</button>' +
    '</div>' +
    /* Overlay ✏️ DESSIN — l'action vedette a son propre tiroir, avec SON apercu : la dissolution
       doit se jouer la ou le client vient de cliquer. */
    '<div class="aa-moon-ov" data-ov="dessin" hidden>' +
      '<canvas class="aa-ov-apercu" width="300" height="300"></canvas>' +
      '<div class="aa-ov-ctrls aa-ov-ctrls-row">' +
        '<span class="aa-ov-lbl">' + T('dessinHint', 'Votre photo, redessinée au trait') + '</span>' +
      '</div>' +
      '<button type="button" class="aa-ov-dessin">' + T('dessinGo', '✏️ Transformer en dessin gravé') + '</button>' +
      '<button type="button" class="aa-ov-relance" hidden></button>' +
      '<button type="button" class="aa-ov-ok">' + T('ok', '✓ Valider') + '</button>' +
    '</div>';

  var wrapEl = stage.querySelector('.aa-moon-wrap');
  var cv2 = stage.querySelector('.aa-moon-cv2d');
  // (le voile de revelation est monte plus bas, une fois wrapEl connu)
  var roomEl = stage.querySelector('.aa-moon-room');
  var lightBtn = stage.querySelector('.aa-moon-light');
  var hintEl = stage.querySelector('.aa-moon-hint');
  var colorsEl = stage.querySelector('.aa-moon-colors');
  var railBtns = [].slice.call(stage.querySelectorAll('.aa-mt'));

  /* ══ LA REVELATION SE JOUE SUR LA LAMPE, PAS DANS LE TIROIR ══════════════════════════
     Correction du 08/09/2026 (soir), demandee par le fondateur :
       « une fois que l'IA transforme la photo en dessin, le dessin doit apparaitre sur la
         LAMPE et non pas sur le modal du studio, pour garantir le majestic wow effect »

     Il a raison, et ma mesure precedente etait juste mais ma conclusion fausse. J'avais
     mesure UNE facon de faire — reconstruire les deux textures 2048x1024 a chaque image,
     105 ms = 9 images/s, injouable — puis j'avais deplace l'effet au lieu de chercher
     l'autre facon. La lampe est le produit : un effet dans le modal celebre l'outil, sur la
     lampe il celebre ce que le client achete.

     L'AUTRE FACON — un seul rebuild, cache derriere le rideau :
       1. on PHOTOGRAPHIE la lune telle qu'elle est, sans le dessin ;
       2. on pose cette photo en calque par-dessus la lune ;
       3. derriere le calque, on reconstruit les textures UNE fois : les 105 ms passent,
          invisibles, parce que rien de ce qui bouge n'est encore visible ;
       4. le calque se retire du haut vers le bas, ligne d'or sur le front d'onde ;
       5. ce qui apparait dessous, c'est la lune gravee.
     Le balayage ne deplace qu'une image FIGEE (clip-path + transform) : rien n'est
     reconstruit pendant l'animation, elle tient sur un telephone.

     PIEGE DEJA RESOLU DANS LE DEPOT : photographier un canvas WebGL echoue normalement, le
     tampon etant vide apres chaque image (`preserveDrawingBuffer: false`). aa-moon-3d.js
     expose un `snapshot()` qui RE-REND juste avant de capturer, dans le meme tick.

     L'ancien eclat d'or plein cadre a ete RETIRE : la ligne d'or du voile fait desormais le
     meme travail, sur le meme objet. Deux balayages dores a la suite se lisent comme un bug. */
  var VOILE_MS = 1700;                 // la duree des coques, a l'identique
  var voileEl = null, voileImg = null, _voileT = 0, _voileFilet = 0;
  (function monterVoile() {
    voileEl = document.createElement('div');
    voileEl.className = 'aa-moon-voile'; voileEl.hidden = true;
    voileImg = document.createElement('img');
    voileImg.className = 'aa-moon-voile-av'; voileImg.alt = '';
    var or = document.createElement('div'); or.className = 'aa-moon-voile-or';
    voileEl.appendChild(voileImg); voileEl.appendChild(or);
    wrapEl.appendChild(voileEl);
  })();

  /* La lune telle qu'elle est A CET INSTANT. Renvoie null si la capture echoue — auquel cas
     la revelation se fera sans voile : le dessin apparait sec, mais il apparait. Un effet
     rate ne doit jamais retenir le resultat. */
  function photoDeLaLune() {
    try {
      if (st.mode === '3d' && st.gl && st.gl.snapshot) return st.gl.snapshot();
      if (cv2 && cv2.width > 2) return cv2.toDataURL('image/png');
    } catch (e) {}
    return null;
  }

  /* Chaque etape attend la PROCHAINE IMAGE — mais requestAnimationFrame est EN PAUSE quand
     l'onglet passe en arriere-plan (le client clique, puis regarde une notification). Sans
     filet, il reviendrait sur une lune restee sous son rideau. */
  function prochaineImage(cb) {
    var fait = false;
    var go = function () { if (fait) return; fait = true; cb(); };
    requestAnimationFrame(go);
    setTimeout(go, 140);
  }

  /* TENUE DE FACE APRES LE VOILE — retour fondateur 15/09. Avant, la lune reprenait sa
     respiration 1,6 s apres le voile : le dessin quittait le champ en ~15 s et le client qui
     lisait la fiche ne le retrouvait qu'au tour suivant. On la tient de face ~6 s (4,5 s ici
     + l'inertie de 1,6 s du moteur), sans jamais relacher un tiroir ouvert entre-temps. */
  var TENUE_APRES_VOILE_MS = 4500;
  var _tenueT = 0;
  function relacherApresTenue() {
    clearTimeout(_tenueT);
    _tenueT = setTimeout(function () {
      if (stage.querySelector('.aa-moon-pop:not([hidden]), .aa-moon-ov:not([hidden])')) return;
      if (st.gl && st.gl.setHold) st.gl.setHold(false);   // la lune reprend sa respiration
    }, TENUE_APRES_VOILE_MS);
  }
  function revelerSurLaLune(appliquer, fin) {
    var termine = false;
    var finir = function () {
      if (termine) return;
      termine = true;
      clearTimeout(_voileT); clearTimeout(_voileFilet);
      if (voileEl) { voileEl.hidden = true; voileEl.classList.remove('court'); }
      relacherApresTenue();
      if (fin) fin();
    };
    var url = voileEl ? photoDeLaLune() : null;
    if (!url) { appliquer(); clearTimeout(_mapsT); rebuildMaps(); finir(); return; }
    /* La lune est IMMOBILISEE et ramenee de face : sinon elle tourne derriere un calque fige
       et, au moment ou le calque se retire, les deux ne coincident plus. */
    if (st.gl && st.gl.setHold) { st.gl.setHold(true); st.gl.spinTo(0); }
    // filet global : quoi qu'il arrive, l'etat se commit et le rideau se leve
    _voileFilet = setTimeout(finir, VOILE_MS + 2500);
    voileImg.onload = voileImg.onerror = function () {
      voileImg.onload = voileImg.onerror = null;
      voileEl.hidden = false;
      voileEl.classList.remove('court');
      prochaineImage(function () {
        /* Le rideau est REELLEMENT peint : on peut payer les 105 ms sans que ca se voie.
           `clearTimeout(_mapsT)` court-circuite l'anti-rebond de rebuildMapsSoon — attendre
           140 ms de plus laisserait le rideau ferme sur rien. */
        appliquer();
        clearTimeout(_mapsT); rebuildMaps();
        /* Le balayage ne part QU'APRES le rebuild. Sur un telephone lent il prend 300 ms au
           lieu de 105 ; lance avant, il saccaderait pile sur ses premieres images. */
        prochaineImage(function () {
          /* La course de la ligne d'or, en pixels, mesuree MAINTENANT : c'est le seul moment
             ou la hauteur du cadre est certaine. Si elle est nulle (cadre replie, onglet en
             arriere-plan), la ligne reste immobile mais le balayage, lui, se joue quand meme. */
          var h = Math.round(wrapEl.getBoundingClientRect().height);
          voileEl.style.setProperty('--aa-front', (h > 0 ? h : 0) + 'px');
          voileEl.classList.add('court');
          _voileT = setTimeout(finir, VOILE_MS + 80);
        });
      });
    };
    voileImg.src = url;
  }

  var mwEl = null, _mwPh = null;
  (function mountStage() {
    var wrap = (document.querySelector('#MediaGallery-' + SID) && document.querySelector('#MediaGallery-' + SID).closest('.product__media-wrapper')) || document.querySelector('.product__media-wrapper');
    if (wrap) { mwEl = wrap; var mg = wrap.querySelector('media-gallery'); if (mg) mg.style.display = 'none'; wrap.appendChild(stage); }
    else { var fb = byId('aa-moon-controls') || document.body; fb.parentNode ? fb.parentNode.insertBefore(stage, fb) : fb.appendChild(stage); }
  })();

  // ── Repli 2D : rendu immédiat ──
  var ctx2 = cv2.getContext('2d');
  function paint2D() {
    if (st.mode === '3d') return;
    // le canvas 2D épouse le format réel du wrap (portrait mobile / paysage desktop) — sinon distorsion
    var wr = wrapEl.getBoundingClientRect();
    if (wr.width > 40 && wr.height > 40) {
      var targetH = Math.round(640 * wr.height / wr.width);
      if (Math.abs(cv2.height - targetH) > 4) cv2.height = targetH;
    }
    M.drawFallback(ctx2, cv2.width, cv2.height, {
      albedo: st.albedo, ref: st.ref, lit: st.lit, color: st.color, trait: st.dessin,
      face: st.face, textPlate: st.text ? M.textPlate(st.text) : null
    });
  }
  paint2D();

  function setAmbiance(e) {
    roomEl.style.opacity = String(0.25 + 0.75 * e);
    stage.classList.toggle('is-lit', e > 0.45);
  }
  setAmbiance(1);

  // ── Maps / Référence (VERBATIM) ──
  var _mapsT = 0;
  function rebuildMapsSoon() { clearTimeout(_mapsT); _mapsT = setTimeout(rebuildMaps, 140); }
  function rebuildMaps() {
    if (!st.albedo) { if (st.albedoKO && st.mode === '3d') to2D(); return; }
    if (st.mode === '3d' && st.gl) {
      var maps = M.buildMaps(st.albedo, st.ref, st.text, { trait: st.dessin });
      st.gl.setMaps(maps.map, maps.emissive);
    } else { paint2D(); }
  }
  var _refT = 0;
  function rebuildRefSoon() { clearTimeout(_refT); _refT = setTimeout(rebuildRef, 160); }
  /* UN SEUL endroit qui fabrique les options de rendu. Le drapeau `trait` change la polarite
     dans tout le moteur (le trait fait de l'ombre au lieu d'ajouter de la lumiere) ; s'il
     manquait a un seul appel, cet apercu-la contredirait les autres. */
  function optsRef(extra) {
    var o = { fond: st.fond, strokes: st.strokes, trait: st.dessin };
    if (extra) for (var k in extra) o[k] = extra[k];
    return o;
  }
  function rebuildRef() {
    if (!st.photo) { st.ref = null; rebuildMapsSoon(); syncProps(); return; }
    st.ref = M.renderReference(st.photo, st.crop, st.bright, optsRef());
    drawCrop(); drawErase();
    rebuildMapsSoon(); syncProps(); relabelCTA(); syncGauge();
    if (typeof syncFrameActions === 'function') syncFrameActions();
    var thumbEl = byId('aa-moon-upthumb');
    if (thumbEl && st.ref) thumbEl.src = M.flattenPrint(st.ref).toDataURL('image/jpeg', 0.6);
    if (typeof refreshTraySoon === 'function') refreshTraySoon();
  }

  // ── Lumière / couleurs ──
  function setLit(on) {
    st.lit = !!on;
    lightBtn.setAttribute('aria-pressed', String(st.lit));
    var mot = st.lit ? T('turnOff', 'Éteindre') : T('turnOn', 'Allumer');
    lightBtn.setAttribute('aria-label', mot); lightBtn.setAttribute('title', mot);
    if (st.mode === '3d' && st.gl) st.gl.setLit(st.lit);
    else { setAmbiance(st.lit ? 1 : 0); paint2D(); }
  }
  lightBtn.addEventListener('click', function () { setLit(!st.lit); });
  function setColor(hex) {
    st.color = hex;
    [].forEach.call(colorsEl.children, function (b) { var on = b.dataset.c === hex; b.classList.toggle('active', on); b.setAttribute('aria-pressed', String(on)); });
    if (st.mode === '3d' && st.gl) st.gl.setColor(hex);
    else paint2D();
    if (!st.lit) setLit(true);
    syncProps();
  }
  function renderSwatches(mode) {
    var pal = paletteFor(mode);
    colorsEl.innerHTML = '';
    pal.forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'aa-moon-sw' + (c === st.color ? ' active' : '');
      b.dataset.c = c; b.style.background = c;
      b.setAttribute('aria-label', COLOR_NAMES[c] || c);
      b.setAttribute('aria-pressed', String(c === st.color));
      b.addEventListener('click', function () { setColor(c); });
      colorsEl.appendChild(b);
    });
    if (pal.indexOf(st.color) < 0) setColor(pal[0]);
  }

  // ── Variante native (déroulants) ──
  function curVariant() {
    var idInput = form && form.querySelector('input[name="id"]');
    var vid = idInput && idInput.value;
    for (var sku in VMAP) { if (String(VMAP[sku].id) === String(vid)) return VMAP[sku]; }
    return null;
  }
  var _lastMode = '';
  function onVariantChange() {
    var v = curVariant(); if (!v) { relabelCTA(); return; }
    if (v.mode !== _lastMode) { _lastMode = v.mode; renderSwatches(v.mode); }
    relabelCTA();
    if (typeof packVariantChanged === 'function') packVariantChanged();
  }
  if (form) {
    form.addEventListener('change', function () { setTimeout(onVariantChange, 60); });
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(onVariantChange, 60); });
  }

  // ── 3D ──
  function to2D() {
    if (st.gl) { try { st.gl.destroy(); } catch (e) {} st.gl = null; }
    st.mode = '2d'; stage.classList.add('is-2d');
    cv2.style.display = '';
    setAmbiance(st.lit ? 1 : 0); paint2D();
  }
  function hydrate3D() {
    if (!window.AAMoon3D || !AAMoon3D.webglOk()) { to2D(); return; }
    AAMoon3D.create(wrapEl, {
      threeUrl: BASE + CFG.three,
      dispImg: st.dispImg,
      color: st.color,
      onTap: function () { setLit(!st.lit); },
      onAmbiance: setAmbiance,
      onTooSlow: function () { console.warn('[aa-moon] watchdog perf → repli 2D'); to2D(); }
    }).then(function (gl) {
      if (!gl) { to2D(); return; }
      st.gl = gl; st.mode = '3d'; stage.classList.remove('is-2d');
      cv2.style.display = 'none';
      window['__aaMoonGl_' + SID] = gl;
      rebuildMaps(); st.gl.setLit(st.lit); st.gl.setColor(st.color);
    }).catch(function () { to2D(); });
  }
  M.loadImage(BASE + CFG.albedo).then(function (img) { st.albedo = img; paint2D(); rebuildMapsSoon(); })
    .catch(function () { st.albedoKO = true; console.warn('[aa-moon] albédo KO'); if (st.mode === '3d') to2D(); });
  var dispP = M.loadImage(BASE + CFG.disp).then(function (img) { st.dispImg = img; return img; }).catch(function () { return null; });
  var idle = function (f) { if (window.requestIdleCallback) { requestIdleCallback(f, { timeout: 1500 }); } else { setTimeout(f, 400); } };
  idle(function () {
    Promise.race([dispP, new Promise(function (r) { setTimeout(r, 4000); })]).then(function () { hydrate3D(); });
  });

  var _hintOff = function () { hintEl.classList.add('off'); stage.removeEventListener('pointerdown', _hintOff); };
  stage.addEventListener('pointerdown', _hintOff);

  // ── Colonne : upload + statut + jauge ──
  var upZone = byId('aa-moon-up'), upInput = byId('aa-moon-file'), upDone = byId('aa-moon-updone'),
    statusEl = byId('aa-moon-status'), gaugeEl = byId('aa-moon-gauge'), badgeEl = byId('aa-moon-badge');
  /* 20/09 : « quand la transformation echoue, le message n'est pas visible et le client croit que sa photo
     s'est transformee » (fondateur, teste sur le site). La ligne d'etat vit dans le tiroir ; le client, lui,
     regarde la lune. Le verdict s'affiche donc SUR la lune, en bandeau, quelques secondes — rouge pour un
     echec ou un refus, vert pour un succes. Styles en ligne : aucune feuille de style a toucher. */
  var bandeauEl = null, bandeauTimer = 0;
  function bandeau(msg, kind) {
    if (!stage) return;
    if (!bandeauEl) {
      bandeauEl = document.createElement('div');
      bandeauEl.className = 'aa-moon-bandeau';
      bandeauEl.setAttribute('role', 'alert');
      bandeauEl.style.cssText = 'position:absolute;left:14px;right:14px;top:14px;z-index:60;padding:14px 18px;border-radius:14px;' +
        'font:600 15px/1.35 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;color:#fff;text-align:center;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.35);pointer-events:none;opacity:0;transition:opacity .25s;';
      stage.appendChild(bandeauEl);
    }
    bandeauEl.textContent = msg;
    bandeauEl.style.background = kind === 'ok' ? 'rgba(24,128,64,.96)' : 'rgba(196,32,32,.96)';
    bandeauEl.style.opacity = '1';
    clearTimeout(bandeauTimer);
    bandeauTimer = setTimeout(function () { if (bandeauEl) bandeauEl.style.opacity = '0'; }, kind === 'ok' ? 4500 : 9000);
  }
  function setStatus(msg, isErr) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('err', !!isErr);
  }
  function syncGauge() {
    if (!gaugeEl) return;
    var steps = [
      { k: 'Photo', ok: !!st.photo },
      { k: T('gReg', 'Réglages'), ok: st.touched.reglages || st.fond !== 'ovale' || st.strokes.length > 0 || st.bright !== 1 },
      { k: T('gCad', 'Cadrage'), ok: st.touched.cadrage }
    ];
    gaugeEl.innerHTML = steps.map(function (s) { return '<span class="' + (s.ok ? 'ok' : '') + '">' + (s.ok ? '●' : '○') + ' ' + s.k + '</span>'; }).join('');
    if (badgeEl) badgeEl.style.display = st.ref ? '' : 'none';
  }

  /* ── DETOURAGE AUTOMATIQUE (fal.ai, via le worker) ────────────────────────────────────────
     Sur une lithophane, le blanc laisse passer la lumiere et le noir fait l'ombre : un fond charge
     occupe toute la surface de la lune et le visage s'y noie. On nettoie donc le fond des l'envoi.

     Trois regles :
       1. La photo d'origine est affichee IMMEDIATEMENT — le client n'attend jamais devant un vide.
       2. Le detourage arrive apres coup et remplace l'image en douceur ; s'il echoue, personne ne
          le voit et la photo d'origine reste. Une panne fal.ai ne doit JAMAIS couter une vente.
       3. Le client peut revenir a sa photo d'origine en un clic. Verifie le 05/09/2026 : sur une
          photo au sujet ambigu, le modele peut se tromper de sujet — le retour arriere n'est pas
          un confort, c'est le filet.
     Tous les reglages (cadrage, luminosite, gomme, fond) continuent de s'appliquer par-dessus,
     puisqu'ils operent sur st.photo, quelle que soit sa provenance. */
  function syncCutBouton() {
    if (!cutBtn) return;
    /* Dessin actif : la gravure a deja enleve le decor. Proposer « enlever le fond » ferait
       payer un appel pour rien et donnerait un bouton sans effet visible. On le range. */
    cutBtn.hidden = !!st.dessin;
    var lbl;
    if (st.cutEnCours) lbl = T('cutWait', '✨ Nettoyage en cours…');
    else if (!st.photoCut) lbl = T('cutGo', '✨ Enlever l’arrière-plan');
    else if (st.cut) lbl = T('cutBack', '↩︎ Remettre l’arrière-plan');
    else lbl = T('cutRedo', '✨ Enlever l’arrière-plan');
    cutBtn.textContent = lbl;
    cutBtn.disabled = !!st.cutEnCours || !!st.cutAnim;
  }

  /* LA DISSOLUTION — c'est elle, l'effet. Un fondu du decor vers le sujet detoure, sur la
     toile que le client a sous les yeux au moment ou il clique. Ease-out cubique : le decor
     part vite puis se pose, ce qui se lit comme « ca s'efface » et non « ca a change ». */
  function animerDissolution(depuis, vers, duree, fin) {
    var toile = toileOuverte();
    if (!toile || !depuis || !vers) { if (fin) fin(); return; }
    var eraseCtx = toile.ctx, s = toile.cv.width, t0 = (window.performance || Date).now();
    st.cutAnim = true;
    syncCutBouton(); syncDessinBouton();   // indisponibles, et ca se voit
    // Resolution UNE SEULE FOIS, que ce soit rAF ou la minuterie de secours qui arrive en premier.
    var fini = false;
    var terminer = function () {
      if (fini) return;
      fini = true; st.cutAnim = false;
      clearTimeout(filet);
      syncCutBouton(); syncDessinBouton();   // redeviennent cliquables
      if (fin) fin();
    };
    // Filet : onglet en arriere-plan = rAF en pause, la dissolution ne battrait jamais.
    var filet = setTimeout(terminer, duree + 600);
    var frame = function (now) {
      if (fini) return;
      var t = Math.min(1, (now - t0) / duree);
      var e = 1 - Math.pow(1 - t, 3);
      eraseCtx.clearRect(0, 0, s, s);
      poserSol(eraseCtx, s);   // MEME sol que drawErase, sinon l'image saute en fin d'animation
      eraseCtx.globalAlpha = 1; eraseCtx.drawImage(depuis, 0, 0);
      eraseCtx.globalAlpha = e; eraseCtx.drawImage(vers, 0, 0);
      eraseCtx.globalAlpha = 1;
      if (t < 1) requestAnimationFrame(frame);
      else terminer();
    };
    requestAnimationFrame(frame);
  }

  /* Bascule fond nettoye <-> photo d'origine. Ne coute RIEN apres le premier appel :
     les deux versions restent en memoire, on ne repaie jamais un aller-retour. */
  /* SOURCE UNIQUE DE VERITE de l'image courante. Le dessin l'emporte sur le detourage :
     la gravure IA a deja retire le decor, superposer les deux n'a pas de sens. */
  function imageCourante(dessin, cut) {
    if (dessin && st.photoDessin) return st.photoDessin;
    if (cut && st.photoCut) return st.photoCut;
    return st.photoOrig;
  }
  function appliquerCut(veut) {
    if (!st.photoCut || !st.photoOrig || st.cutAnim) return;
    var t1 = toileOuverte(), s = t1 ? t1.cv.width : 300;
    var o = optsRef({ size: s });
    var depuis = M.renderReference(imageCourante(st.dessin, st.cut), st.crop, st.bright, o);
    var vers = M.renderReference(imageCourante(st.dessin, veut), st.crop, st.bright, o);
    st.cut = veut;
    st.photo = imageCourante(st.dessin, veut);
    st.touched.reglages = true;   // la jauge doit compter ce geste comme un reglage fait
    syncCutBouton();
    /* COMMIT D'ABORD, DECOR ENSUITE. L'onglet peut passer en arriere-plan pendant l'appel
       (sur mobile : le client clique puis regarde une notification) — requestAnimationFrame
       est alors EN PAUSE. Si l'etat metier attendait la fin de l'animation, _aa_design
       resterait a cut:false alors que le client a bien enleve le fond, et le fournisseur
       recevrait une consigne fausse. rebuildRef() ecrit les proprietes panier tout de suite ;
       drawErase() est neutralise pendant la dissolution par le garde st.cutAnim. */
    rebuildRef();
    animerDissolution(depuis, vers, 850, function () { drawErase(); });
  }

  /* ── GRAVURE EN DESSIN ─────────────────────────────────────────────────────────────────
     Le portefeuille ne grave pas une photo : il grave un DESSIN, et c'est ce qui fait sa beaute
     (verdict fondateur 07/09/2026, planche comparative a l'appui). Meme prompt, meme modele.

     Pourquoi c'est aussi le bon format pour l'objet : une lithophane traduit de l'EPAISSEUR.
     Une photo en gris, ce sont des milliers de nuances voisines — a travers 2-3 mm de resine
     elles se melangent. Un dessin n'a que deux valeurs, le trait et le vide : il traverse la
     matiere sans se perdre. Et le trait fait de l'OMBRE (matiere en plus), d'ou `trait:true`
     qui bascule tout le moteur de `lighten` vers `multiply`.

     Le risque, nomme par le fondateur : l'IA redessine, le client ne se reconnait pas, il
     relance en boucle et on paie chaque essai avant qu'il parte sans acheter. Trois protections :
       1. UN SEUL appel par photo — le resultat est garde, basculer dessin <-> photo est gratuit ;
       2. la photo d'origine reste accessible en un clic, toujours ;
       3. les relances sont PLAFONNEES (DESSIN_RELANCES_MAX) — au pire 0,12 $ par client. */
  function pngEncre(blob) {
    return new Promise(function (ok, ko) {
      var url = URL.createObjectURL(blob);
      var im = new Image();
      im.onload = function () {
        URL.revokeObjectURL(url);
        try {
          var maxSide = 1400, w = im.naturalWidth || im.width, h = im.naturalHeight || im.height;
          var k = Math.min(1, maxSide / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.round(w * k); c.height = Math.round(h * k);
          var x = c.getContext('2d');
          x.fillStyle = '#ffffff'; x.fillRect(0, 0, c.width, c.height); // le modele rend du blanc pur
          x.drawImage(im, 0, 0, c.width, c.height);
          /* Le PAPIER devient TRANSPARENT, le TRAIT garde sa valeur de gris. En `multiply`, un
             trait a 40 % d'encre assombrit la lune de 40 % : le crayonne et ses bords doux
             survivent. Aplatir en noir/blanc durcirait tout. */
          var im2 = x.getImageData(0, 0, c.width, c.height), p = im2.data, i, y;
          for (i = 0; i < p.length; i += 4) {
            y = p[i] * 0.2126 + p[i + 1] * 0.7152 + p[i + 2] * 0.0722;
            p[i + 3] = Math.max(0, Math.min(255, Math.round((245 - y) * 255 / 200)));
          }
          x.putImageData(im2, 0, 0);
          ok(c);
        } catch (e) { ko(e); }
      };
      im.onerror = function () { URL.revokeObjectURL(url); ko(new Error('gravure illisible')); };
      im.src = url;
    });
  }

  function syncDessinBouton() {
    if (!dessinBtn) return;
    var lbl;
    if (st.dessinEnCours) lbl = T('dessinWait', '✏️ Gravure en cours…');
    else if (!st.photoDessin) lbl = T('dessinGo', '✏️ Transformer en dessin gravé');
    else if (st.dessin) lbl = T('dessinBack', '↩︎ Revenir à ma photo');
    else lbl = T('dessinRedo', '✏️ Remettre le dessin');
    dessinBtn.textContent = lbl;
    dessinBtn.disabled = !!st.dessinEnCours || !!st.cutAnim;
    if (relanceBtn) {
      var reste = DESSIN_RELANCES_MAX - st.dessinRelances;
      relanceBtn.hidden = !st.photoDessin || !!st.dessinEnCours;
      relanceBtn.disabled = reste <= 0 || !!st.cutAnim;
      /* Le compte est AFFICHE : le client decide en connaissance de cause au lieu de decouvrir
         un refus. Un plafond invisible ressemble a une panne. */
      relanceBtn.textContent = reste > 0
        ? T('relance', '↻ Essayer un autre dessin') + ' (' + reste + ')'
        : T('relanceFin', '↻ Plus d’essai disponible');
    }
  }

  /* Bascule dessin <-> photo. Ne coute RIEN : les deux versions vivent en memoire.
     `surLaLune` : la revelation d'un dessin QUI VIENT D'ARRIVER se joue sur la lampe (voir
     revelerSurLaLune). Ce chemin-la n'anime donc rien dans le tiroir — le tiroir est ferme. */
  function appliquerDessin(veut, surLaLune) {
    if (!st.photoDessin || !st.photoOrig || st.cutAnim) return;
    if (surLaLune) {
      st.dessin = veut;
      st.photo = imageCourante(veut, st.cut);
      st.touched.reglages = true;
      syncDessinBouton(); syncCutBouton();
      rebuildRef();   // commit des proprietes panier AVANT tout decor (voir appliquerCut)
      return;
    }
    var t2 = toileOuverte(), s2 = t2 ? t2.cv.width : 300;
    var depuis = M.renderReference(imageCourante(st.dessin, st.cut), st.crop, st.bright, optsRef({ size: s2 }));
    st.dessin = veut;
    st.photo = imageCourante(veut, st.cut);
    st.touched.reglages = true;
    syncDessinBouton(); syncCutBouton();
    // COMMIT D'ABORD (voir appliquerCut) : l'onglet peut passer en arriere-plan pendant l'animation.
    rebuildRef();
    var vers = M.renderReference(st.photo, st.crop, st.bright, optsRef({ size: s2 }));
    /* Bascule manuelle depuis le tiroir (le client rebascule dessin <-> photo) : dissolution
       sobre, ici. Le voile en or est reserve a la VRAIE revelation, sur la lampe — on ne
       celebre pas deux fois la meme chose, ni un retour en arriere. */
    animerDissolution(depuis, vers, 850, function () { drawErase(); });
  }

  function lancerDessin() {
    if (!CFG.workerUrl || !st.photoOrig || st.dessinEnCours) return;
    if (st.photoDessin && st.dessinRelances >= DESSIN_RELANCES_MAX) {
      // Plafond atteint : on ne bloque pas le client, on lui rend la main sur ce qu'il a deja.
      setStatus(T('dessinMax', 'Vous avez déjà 2 essais — gardez le dessin ou votre photo, ou changez de photo.'), true);
      return;
    }
    st.dessinEnCours = true;
    syncDessinBouton();
    setStatus(T('dessinWaitMsg', '✏️ On dessine votre souvenir… une dizaine de secondes.'));
    var jeton = ++st.cutJeton;   // le meme jeton que le detourage : changer de photo invalide tout
    var tri = '';                // 'photo' | 'graphique' (en-tete X-AA-Tri du worker, 19/09)
    var refus = '';              // 'filtre' : l'IA a refuse la photo (en-tete X-AA-Refus, 20/09) — ce n'est pas une panne
    blobDe(st.photoOrig)
      .then(function (blob) {
        if (!blob) throw new Error('encodage impossible');
        var ac = new AbortController();
        var tt = setTimeout(function () { ac.abort(); }, 60000); // le modele de dessin est plus lent
        return fetch(CFG.workerUrl + '/api/moon-engrave', {
          method: 'POST', headers: { 'Content-Type': 'application/octet-stream' },
          body: blob, signal: ac.signal
        }).then(function (r) { clearTimeout(tt); try { tri = r.headers.get('X-AA-Tri') || ''; refus = r.headers.get('X-AA-Refus') || ''; } catch (e) {} return r.ok ? r.blob() : null; });
      })
      .then(function (png) { return png ? pngEncre(png) : null; })
      .then(function (cv) {
        st.dessinEnCours = false;
        if (!cv || jeton !== st.cutJeton || !st.photo) { syncDessinBouton(); if (!cv) throw new Error('refus'); return; }
        if (st.photoDessin) st.dessinRelances++;   // on ne compte que les RE-lances
        st.photoDessin = cv;
        /* DESSIN FIDELE (19/09) : un trace, une ecriture, un logo (tri « graphique » du worker)
           courent souvent d'un bord a l'autre ; le medaillon en fondrait les extremites. Le fond
           passe a « plein » — sauf si le client a deja choisi son fond lui-meme. */
        if (tri === 'graphique' && st.fond === 'ovale' && !st.fondChoisi) { st.fond = 'plein'; syncFondButtons(); }
        /* LA SCENE REVIENT A LA LUNE. Le tiroir couvre le stage a 72 % d'opacite : tant qu'il
           est ouvert, la lampe n'est pas visible et il n'y a rien a reveler. On ferme, puis on
           joue le voile sur la lune. Le client ne perd rien — le crayon du rail lui rend le
           tiroir, avec « revenir a ma photo » et les relances. */
        closeAll();
        revelerSurLaLune(function () { appliquerDessin(true, true); });
        setStatus(st.dessinRelances >= DESSIN_RELANCES_MAX
          ? T('dessinOkMax', '✏️ Votre dessin est gravé — dernier essai disponible utilisé.')
          : T('dessinOk', '✏️ Votre dessin est gravé — vous pouvez revenir à la photo à tout moment.'));
        bandeau(T('dessinOkBandeau', '✏️ Votre photo a été transformée en dessin'), 'ok');
      })
      .catch(function () {
        st.dessinEnCours = false;
        syncDessinBouton();
        /* 20/09 : le filtre de contenu du prestataire IA refuse certaines photos (vu en prod : deux enfants
           a la plage). Dire « reessayez » etait faux — le client reessayait pour rien. On le dit, et on
           rappelle qu'il peut garder sa photo telle quelle. */
        var msgKo = refus
          ? T('dessinRefus', '❌ L’IA a refusé de dessiner cette photo (filtre de contenu du prestataire). Votre photo n’a PAS été transformée — gardez-la telle quelle ou essayez-en une autre.')
          : T('dessinKo', '❌ La transformation n’a pas abouti : votre photo n’a PAS été transformée, elle reste telle quelle. Réessayez.');
        setStatus(msgKo, true);
        bandeau(msgKo, 'err');
      });
  }

  function blobDe(cv) {
    return new Promise(function (r) { cv.toBlob(function (b) { r(b); }, 'image/jpeg', 0.92); });
  }
  /* On GARDE la transparence rendue par le modèle. La version précédente l'aplatissait sur du
     blanc « parce que sur une lithophane le blanc laisse passer la lumière » — raisonnement juste
     pour l'objet physique, faux pour le rendu : la lune compose la photo en `lighten`, où le blanc
     gagne toujours. Résultat : un rectangle éblouissant autour du sujet, et le sujet lui-même
     (plus sombre que la lune) qui disparaissait. La transparence est le seul neutre commun aux
     deux modes du moteur (`multiply` éteinte, `lighten` allumée). */
  function pngTransparent(blob) {
    return new Promise(function (ok, ko) {
      var url = URL.createObjectURL(blob);
      var im = new Image();
      im.onload = function () {
        URL.revokeObjectURL(url);
        try {
          var maxSide = 1600, w = im.naturalWidth || im.width, h = im.naturalHeight || im.height;
          var k = Math.min(1, maxSide / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.round(w * k); c.height = Math.round(h * k);
          c.getContext('2d').drawImage(im, 0, 0, c.width, c.height); // toile transparente, alpha conservé
          ok(c);
        } catch (e) { ko(e); }
      };
      im.onerror = function () { URL.revokeObjectURL(url); ko(new Error('png illisible')); };
      im.src = url;
    });
  }

  /* Appel PAYANT — uniquement sur clic du client, jamais a l'envoi de la photo.
     Un seul appel par photo : le resultat est garde, les bascules suivantes sont gratuites.
     Toute panne est un echec DOUX : la photo d'origine reste, la gomme manuelle prend le relais,
     et la vente n'est jamais bloquee. */
  function lancerDetourage() {
    if (!CFG.workerUrl || !st.photoOrig || st.cutEnCours) return;
    st.cutEnCours = true;
    syncCutBouton();
    var jeton = ++st.cutJeton;   // le client peut changer de photo pendant l'appel
    blobDe(st.photoOrig)
      .then(function (blob) {
        if (!blob) throw new Error('encodage impossible');
        var ac = new AbortController();
        var tt = setTimeout(function () { ac.abort(); }, 25000);
        return fetch(CFG.workerUrl + '/api/moon-cutout', {
          method: 'POST', headers: { 'Content-Type': 'application/octet-stream' },
          body: blob, signal: ac.signal
        }).then(function (r) { clearTimeout(tt); return r.ok ? r.blob() : null; });
      })
      .then(function (png) { return png ? pngTransparent(png) : null; })
      .then(function (cv) {
        st.cutEnCours = false;
        if (!cv || jeton !== st.cutJeton || !st.photo) { syncCutBouton(); return; }
        st.photoCut = cv;
        appliquerCut(true);
        setStatus(T('cutOk', '✨ Fond enlevé — affinez à la gomme si besoin'));
      })
      .catch(function () {
        st.cutEnCours = false;
        syncCutBouton();
        setStatus(T('cutKo', 'Le nettoyage automatique n’a pas abouti — la gomme reste à votre main.'), true);
      });
  }

  // ── Upload ──
  function acceptFile(file) {
    /* 21/09, fondateur (mobile) : un refus d'envoi ecrit dans le tiroir est invisible sur telephone — le client
       ne sait pas s'il s'est passe quelque chose. Les trois refus passent aussi par le bandeau rouge sur la lune. */
    if (!file || !/^image\//.test(file.type)) { var mBad = T('badFile', 'Choisissez une image (JPG ou PNG).'); setStatus(mBad, true); bandeau(mBad, 'err'); return; }
    setStatus(T('loading', 'Chargement de votre photo…'));
    M.loadFile(file).then(function (img) {
      if (M.tooSmall(img)) { var mSmall = T('tooSmall', '⚠️ Photo trop petite (min. 600 px) — elle risquerait d’être pixelisée. Choisissez-en une plus grande.'); setStatus(mSmall, true); bandeau(mSmall, 'err'); return; }
      st.photoOrig = M.prepPhoto(img);
      st.photo = st.photoOrig;   // affichee TOUT DE SUITE ; le detourage la remplacera s'il aboutit
      st.photoCut = null; st.cut = false;
      st.photoDessin = null; st.dessin = false; st.dessinRelances = 0;
      st.crop = { cx: 0.5, cy: 0.5, zoom: 1, rot: 0 };
      st.strokes = []; st.fond = 'ovale'; st.fondChoisi = false; st.touched = { cadrage: false, reglages: false };
      syncFondButtons(); syncCutBouton(); syncDessinBouton();
      st.cutJeton++;   // invalide un detourage encore en vol pour la photo precedente
      rebuildRef();
      if (upZone) upZone.classList.add('has-photo');
      if (upDone) upDone.style.display = '';
      setStatus(T('okPhoto', '✓ Photo ajoutée — transformez-la en dessin gravé'));
      packPhotoChanged();   // pack : cette lune est a re-valider (voir MULTIPACK)
      /* On OUVRE le tiroir DESSIN (consigne fondateur 08/09/2026 : « des que la photo est
         ajoutee, le studio de travail de la photo s'ouvre automatiquement et le client pourra
         cliquer sur le bouton pour transformer sa photo »).
         Ce n'est plus la gomme : le 07/09 l'ouverture visait le choix de l'arriere-plan, mais
         le prompt de gravure rend deja un fond blanc pur — le dessin retire le decor lui-meme.
         La gomme redevient donc un outil de retouche, pas une etape obligatoire.
         On ouvre, on ne clique PAS : le dessin coute 0,039 $ et l'argent ne part que si le
         client le decide. Le bouton est sous ses yeux, la decision reste la sienne. */
      setTimeout(function () {
        var b = null;
        railBtns.forEach(function (x) { if (x.dataset.tool === 'dessin') b = x; });
        if (b && st.photo && ovs.dessin && ovs.dessin.hidden) openTool('dessin', b);
      }, 420);
      setLit(false);
      setTimeout(function () { setLit(true); if (st.gl) st.gl.spinTo(0); }, 620);
      relabelCTA(); syncGauge();
    }).catch(function () { var mKo = T('koPhoto', 'Impossible de lire cette image — réessayez.'); setStatus(mKo, true); bandeau(mKo, 'err'); });
  }
  if (upInput) upInput.addEventListener('change', function () { acceptFile(upInput.files && upInput.files[0]); upInput.value = ''; });
  if (upZone) {
    ['dragover', 'dragenter'].forEach(function (ev) { upZone.addEventListener(ev, function (e) { e.preventDefault(); upZone.classList.add('drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { upZone.addEventListener(ev, function (e) { e.preventDefault(); upZone.classList.remove('drag'); }); });
    upZone.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; acceptFile(f); });
  }

  // ── Rail d'outils : popups + overlays (un seul ouvert à la fois) ──
  /* Declaree AVANT closeAll parce que closeAll doit pouvoir desarmer la gomme ; le vrai
     corps est installe plus bas, une fois le canvas de la gomme connu. */
  var armerGomme = function () {};
  var pops = {}, ovs = {};
  [].forEach.call(stage.querySelectorAll('.aa-moon-pop'), function (p) { pops[p.dataset.pop] = p; });
  [].forEach.call(stage.querySelectorAll('.aa-moon-ov'), function (o) { ovs[o.dataset.ov] = o; });
  function closeAll() {
    for (var k in pops) pops[k].hidden = true;
    for (var k2 in ovs) ovs[k2].hidden = true;
    railBtns.forEach(function (b) { b.classList.remove('active'); });
    armerGomme(false);   // une gomme ne reste JAMAIS armee d'un tiroir a l'autre
    if (st.gl && st.gl.setHold) st.gl.setHold(false); // perso terminée → la lune reprend sa respiration
  }
  function openTool(tool, btn) {
    var wasOpen = (pops[tool] && !pops[tool].hidden) || (ovs[tool] && !ovs[tool].hidden);
    closeAll();
    if (wasOpen) return;
    if (tool === 'photo') { if (upInput) upInput.click(); return; }
    // Outils photo SANS photo : jamais un bouton mort (retour fondateur) → on ouvre direct le sélecteur
    if (!st.photo && (tool === 'cadrage' || tool === 'fond' || tool === 'dessin')) {
      setStatus(T('needPhoto', '📷 Ajoutez votre photo pour créer votre lune'), true);
      if (upInput) upInput.click();
      return;
    }
    if (pops[tool]) { pops[tool].hidden = false; btn.classList.add('active'); } // position = CSS (bas du stage, centré — accessible au pouce)
    if (ovs[tool]) { ovs[tool].hidden = false; btn.classList.add('active'); if (tool === 'cadrage') { drawCrop(); } if (tool === 'fond' || tool === 'dessin') { drawErase(); } }
    if (tool === 'texte') { var ti = pops.texte.querySelector('.aa-pop-text'); if (ti) { ti.value = st.text; setTimeout(function () { ti.focus(); }, 60); } }
    // outil ouvert = la lune s'IMMOBILISE face à toi (verso pour le texte) ; elle repart à la fermeture (closeAll)
    if (st.gl && st.gl.setHold) { st.gl.setHold(true); st.gl.spinTo(tool === 'texte' ? 180 : 0); }
  }
  railBtns.forEach(function (b) {
    b.addEventListener('click', function () { openTool(b.dataset.tool, b); });
  });
  // tap hors popup → fermeture (pattern portefeuille) ; le canvas 3D ferme aussi
  stage.addEventListener('pointerdown', function (e) {
    if (e.target.closest('.aa-moon-pop, .aa-moon-ov, .aa-mt')) return;
    closeAll();
  });

  // ── ☀️ Luminosité (curseur du tiroir Cadrage depuis le 15/09) ──
  var brightRange = ovs.cadrage && ovs.cadrage.querySelector('.aa-ov-bright');
  if (brightRange) brightRange.addEventListener('input', function () {
    st.bright = parseInt(brightRange.value, 10) / 100;
    st.touched.reglages = true;
    drawCropLive(); rebuildRefSoon();   // l'apercu du tiroir suit le curseur, comme le zoom
  });

  // ── 🖼️ Fond ──
  function syncFondButtons() {
    if (!ovs.fond) return;
    [].forEach.call(ovs.fond.querySelectorAll('[data-fond]'), function (b) { b.classList.toggle('active', b.dataset.fond === st.fond); });
  }
  if (ovs.fond) [].forEach.call(ovs.fond.querySelectorAll('[data-fond]'), function (b) {
    b.addEventListener('click', function () {
      st.fond = b.dataset.fond; st.fondChoisi = true; st.touched.reglages = true;
      syncFondButtons(); rebuildRef(); drawErase();   // l'apercu du tiroir montre le nouveau fond
    });
  });

  // ── ✍️ Texte ──
  var textInput = pops.texte && pops.texte.querySelector('.aa-pop-text');
  var textOff = pops.texte && pops.texte.querySelector('.aa-pop-textoff');
  var _textT = 0, _faceT = 0;
  if (textInput) textInput.addEventListener('input', function () {
    st.text = textInput.value.slice(0, 40);
    clearTimeout(_textT);
    _textT = setTimeout(function () {
      rebuildMaps(); syncProps();
      if (st.text && st.gl) st.gl.spinTo(180);
      else if (st.mode === '2d') {
        st.face = st.text ? 'back' : 'front'; paint2D();
        clearTimeout(_faceT);
        if (st.text) _faceT = setTimeout(function () { st.face = 'front'; paint2D(); }, 2200);
      }
      if (!st.text) { st.face = 'front'; if (st.mode === '2d') paint2D(); if (st.gl) st.gl.spinTo(0); }
    }, 260);
  });
  if (textOff) textOff.addEventListener('click', function () {
    st.text = ''; if (textInput) textInput.value = '';
    st.face = 'front'; rebuildMapsSoon(); syncProps();
    if (st.gl) st.gl.spinTo(0); else paint2D();
  });

  // ── 🔍 CADRAGE (overlay) ──
  var cropCv = ovs.cadrage && ovs.cadrage.querySelector('.aa-ov-crop');
  var cropCtx = cropCv ? cropCv.getContext('2d') : null;
  var zoomRange = ovs.cadrage && ovs.cadrage.querySelector('.aa-ov-zoom');
  var netteteEl = ovs.cadrage && ovs.cadrage.querySelector('.aa-ov-net');
  var rotRange = ovs.cadrage && ovs.cadrage.querySelector('.aa-ov-rot');
  function drawCrop() {
    if (!cropCtx || !st.photo || (ovs.cadrage && ovs.cadrage.hidden)) return;
    majNettete();   // a l'ouverture du tiroir aussi : une petite photo alerte des le premier coup d'oeil
    var s = cropCv.width;
    // gravure live à l'échelle éditeur (rapide)
    var eng = M.renderReference(st.photo, st.crop, st.bright, optsRef({ size: s }));
    cropCtx.clearRect(0, 0, s, s);
    cropCtx.fillStyle = FOND_LUNE; cropCtx.fillRect(0, 0, s, s);
    cropCtx.drawImage(eng, 0, 0);
    // hors-disque assombri (le disque = le cœur de la lune)
    cropCtx.save();
    cropCtx.fillStyle = 'rgba(20,22,32,0.55)';
    cropCtx.beginPath(); cropCtx.rect(0, 0, s, s);
    cropCtx.arc(s / 2, s / 2, s * 0.46, 0, Math.PI * 2, true); cropCtx.fill();
    cropCtx.strokeStyle = 'rgba(255,255,255,0.85)'; cropCtx.lineWidth = 2;
    cropCtx.beginPath(); cropCtx.arc(s / 2, s / 2, s * 0.46, 0, Math.PI * 2); cropCtx.stroke();
    cropCtx.restore();
  }
  if (cropCv) {
    cropCv.style.touchAction = 'none';
    var pts = {}, lastDist = 0, lastAng = null;
    cropCv.addEventListener('pointerdown', function (e) { pts[e.pointerId] = e; try { cropCv.setPointerCapture(e.pointerId); } catch (err) {} });
    cropCv.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId] || !st.photo) return;
      var ids = Object.keys(pts);
      if (ids.length === 2) { // pincement : zoom + rotation 2 doigts (parité portefeuille)
        var a0 = pts[ids[0]], b0 = pts[ids[1]];
        var prevD = Math.hypot(a0.clientX - b0.clientX, a0.clientY - b0.clientY);
        var prevA = Math.atan2(b0.clientY - a0.clientY, b0.clientX - a0.clientX);
        pts[e.pointerId] = e;
        var a1 = pts[ids[0]], b1 = pts[ids[1]];
        var d = Math.hypot(a1.clientX - b1.clientX, a1.clientY - b1.clientY);
        var ang = Math.atan2(b1.clientY - a1.clientY, b1.clientX - a1.clientX);
        if (prevD > 20) setZoom(st.crop.zoom * (d / prevD), true);
        var dA = (ang - prevA) * 180 / Math.PI;
        if (Math.abs(dA) < 30) setRot(st.crop.rot + dA, true);
        lastDist = d; lastAng = ang;
      } else {
        var o = pts[e.pointerId];
        var base = Math.min(st.photo.width, st.photo.height) / st.crop.zoom;
        var scale = base / cropCv.getBoundingClientRect().width;
        st.crop.cx -= (e.clientX - o.clientX) * scale / st.photo.width;
        st.crop.cy -= (e.clientY - o.clientY) * scale / st.photo.height;
        /* La borne vient du MOTEUR (`M.clampCrop`), pas d'un `[0,1]` local. L'ancien clamp ne
           pouvait pas exprimer les positions negatives dont la nouvelle course a besoin pour
           atteindre le bord gauche : la moitie de la course serait restee inatteignable, et le
           doigt aurait pousse dans le vide. */
        var borne = M.clampCrop(st.photo, st.crop);
        st.crop.cx = borne.cx; st.crop.cy = borne.cy;
        st.touched.cadrage = true;
        pts[e.pointerId] = e;
        drawCropLive();
      }
    });
    var endP = function (e) { delete pts[e.pointerId]; lastDist = 0; lastAng = null; rebuildRefSoon(); };
    cropCv.addEventListener('pointerup', endP); cropCv.addEventListener('pointercancel', endP);
    cropCv.addEventListener('wheel', function (e) { e.preventDefault(); setZoom(st.crop.zoom * (e.deltaY < 0 ? 1.07 : 0.935)); }, { passive: false });
  }
  var _cropLiveT = 0;
  function drawCropLive() {
    if (_cropLiveT) return;
    _cropLiveT = setTimeout(function () { _cropLiveT = 0; drawCrop(); }, 33); // ~30 fps, indépendant de rAF
  }
  /* ALERTE DE NETTETE — le garde-fou etait du mauvais cote. `tooSmall` ne juge la photo qu'au
     CHARGEMENT ; personne ne regardait ce que le zoom en fait ensuite. Une photo de 600 px poussee
     a zoom 3 partait etiree six fois. On previent donc sur l'agrandissement REEL, en langage de
     client, au moment ou il cree le probleme — et on ne bloque jamais : c'est sa photo. */
  function majNettete() {
    if (!netteteEl) return;
    if (!st.photo) { netteteEl.hidden = true; return; }
    var g = M.agrandissement(st.photo, st.crop.zoom);
    if (g > M.AGRANDISSEMENT_MAX) {
      netteteEl.textContent = T('zoomFlou', '⚠️ À ce niveau de zoom, la gravure risquerait d’être floue. Reculez un peu, ou choisissez une photo plus grande.');
      netteteEl.hidden = false;
    } else netteteEl.hidden = true;
  }
  function setZoom(z, silent) {
    // Bornes tenues par le MOTEUR (M.ZOOM_MIN/MAX) : le plancher etait double, ici et dans
    // drawCovered. Deux sources de verite pour la meme borne, c'est une divergence qui attend.
    st.crop.zoom = Math.min(M.ZOOM_MAX, Math.max(M.ZOOM_MIN, z));
    st.touched.cadrage = true;
    if (zoomRange) zoomRange.value = String(Math.round(st.crop.zoom * 100));
    // Le zoom vient de changer : la fenetre aussi, donc la course de deplacement. On re-borne le
    // cadrage courant, sinon une position valable a zoom 2 resterait hors bornes a zoom 0,2.
    if (st.photo) { var b = M.clampCrop(st.photo, st.crop); st.crop.cx = b.cx; st.crop.cy = b.cy; }
    majNettete();
    drawCropLive(); if (!silent) rebuildRefSoon();
  }
  function setRot(r, silent) {
    st.crop.rot = Math.min(90, Math.max(-90, r));
    st.touched.cadrage = true;
    if (rotRange) rotRange.value = String(Math.round(st.crop.rot));
    drawCropLive(); if (!silent) rebuildRefSoon();
  }
  if (zoomRange) zoomRange.addEventListener('input', function () { setZoom(parseInt(zoomRange.value, 10) / 100); });
  /* « Tout afficher » : pose le zoom exact pour que la photo entiere tienne, et RECENTRE — un
     cadrage decale n'a plus de sens quand on montre tout. Recalcule a chaque clic parce que la
     valeur depend de la rotation courante. */
  var toutBtn = ovs.cadrage && ovs.cadrage.querySelector('.aa-ov-tout');
  if (toutBtn) toutBtn.addEventListener('click', function () {
    if (!st.photo) return;
    st.crop.cx = 0.5; st.crop.cy = 0.5;
    setZoom(M.zoomTout(st.photo, st.crop.rot));
  });
  if (rotRange) rotRange.addEventListener('input', function () { setRot(parseInt(rotRange.value, 10)); });
  [].forEach.call(stage.querySelectorAll('.aa-ov-ok'), function (b) { b.addEventListener('click', function () { closeAll(); rebuildRef(); }); });

  /* SORTIR D'UN OUTIL — retour fondateur 07/09/2026 : « sur toutes les icones il n'y a pas la
     possibilite de quitter le mode ou de retour ». On ne fermait que par re-clic sur l'icone ou
     par tap dans le vide : deux gestes invisibles, et sur un overlay plein ecran on se sent
     enferme. Chaque panneau porte desormais sa croix, TOUJOURS au meme endroit, et Echap ferme.
     La croix GARDE ce qui est affiche — le studio applique en direct, il n'y a rien a valider ;
     le retour arriere de la gomme reste son bouton Annuler. */
  [].forEach.call(stage.querySelectorAll('.aa-moon-pop, .aa-moon-ov'), function (p) {
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'aa-panneau-x'; x.textContent = '✕';
    x.setAttribute('aria-label', T('fermer', 'Fermer'));
    x.setAttribute('title', T('fermer', 'Fermer'));
    x.addEventListener('click', function (e) { e.stopPropagation(); closeAll(); rebuildRef(); });
    p.insertBefore(x, p.firstChild);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!stage.querySelector('.aa-moon-pop:not([hidden]), .aa-moon-ov:not([hidden])')) return;
    closeAll(); rebuildRef();
  });

  // ── 🧽 GOMME MAGIQUE (dans le tiroir Fond — portage portefeuille : blanc, annuler ×20, répercutée sur la référence) ──
  var eraseCv = ovs.fond && ovs.fond.querySelector('.aa-ov-erase');
  var eraseCtx = eraseCv ? eraseCv.getContext('2d') : null;
  var undoBtn = ovs.fond && ovs.fond.querySelector('.aa-ov-undo');
  var cutBtn = ovs.fond && ovs.fond.querySelector('.aa-ov-cut');
  var dessinCv = ovs.dessin && ovs.dessin.querySelector('.aa-ov-apercu');
  var dessinCtx = dessinCv ? dessinCv.getContext('2d') : null;
  var dessinBtn = ovs.dessin && ovs.dessin.querySelector('.aa-ov-dessin');
  var relanceBtn = ovs.dessin && ovs.dessin.querySelector('.aa-ov-relance');
  if (relanceBtn) relanceBtn.addEventListener('click', function () { lancerDessin(); });
  if (dessinBtn) dessinBtn.addEventListener('click', function () {
    if (!st.photoDessin) return lancerDessin();
    if (st.dessin) return appliquerDessin(false);   // gratuit : retour a la photo
    appliquerDessin(true);                          // gratuit : retour au dessin
  });
  var BRUSH = 0.045; // rayon en fraction de la référence
  /* Les deux tiroirs (gomme et dessin) montrent la MEME chose : la reference telle qu'elle
     partira. Un seul rendu, deux toiles — sinon les deux apercus divergent au premier oubli. */
  /* LE SOL DE L'APERCU — une seule fonction, parce que trois peintres en dependent
     (peindreApercu, animerDissolution, erasePoint) et qu'un sol qui diverge se voit
     immediatement : l'image sauterait entre l'animation et l'etat au repos.

     Pourquoi ce n'est pas toujours FOND_LUNE. Une PHOTO est opaque : elle recouvre le sol,
     qui ne sert qu'a habiller les coins. Un DESSIN est du trait sur du vide : le sol EST
     l'image. Mesure du 08/09/2026 — sur FOND_LUNE (#342c21, luminance 46) l'apercu d'un
     dessin tombe a 17,4 de contraste quand la lune en montre 47,5, soit 63 % d'ecart. Le
     voile en or atterrissait donc sur une image trois fois plus plate que la lampe, au
     moment precis cense faire le « wow ». Sous un dessin on pose donc la VRAIE surface
     lunaire eclairee — le meme sol que drawFallback, meme cadrage, meme teinte LED. */
  function poserSol(ctx, s) {
    if (st.dessin && st.albedo) {
      var aw = st.albedo.width, ah = st.albedo.height;
      ctx.drawImage(st.albedo, aw * 0.28, ah * 0.08, aw * 0.44, ah * 0.84, 0, 0, s, s);
      ctx.save();
      ctx.globalCompositeOperation = 'overlay'; ctx.globalAlpha = 0.34;
      ctx.fillStyle = st.color; ctx.fillRect(0, 0, s, s);   // la LED, comme sur la lampe
      ctx.restore();
      return;
    }
    ctx.fillStyle = FOND_LUNE; ctx.fillRect(0, 0, s, s);
  }
  function peindreApercu(cv, ctx) {
    if (!ctx || !st.photo) return;
    var s = cv.width;
    var eng = M.renderReference(st.photo, st.crop, st.bright, optsRef({ size: s }));
    ctx.clearRect(0, 0, s, s);
    poserSol(ctx, s);
    ctx.drawImage(eng, 0, 0);
  }
  /* Toile du tiroir actuellement ouvert : c'est la que la dissolution doit se jouer. */
  function toileOuverte() {
    if (ovs.dessin && !ovs.dessin.hidden && dessinCtx) return { cv: dessinCv, ctx: dessinCtx };
    if (ovs.fond && !ovs.fond.hidden && eraseCtx) return { cv: eraseCv, ctx: eraseCtx };
    return null;
  }
  function drawErase() {
    if (st.cutAnim) return;   // ne pas ecraser la dissolution en cours
    if (eraseCtx && ovs.fond && !ovs.fond.hidden) peindreApercu(eraseCv, eraseCtx);
    if (dessinCtx && ovs.dessin && !ovs.dessin.hidden) peindreApercu(dessinCv, dessinCtx);
  }
  var armerBtn = ovs.fond && ovs.fond.querySelector('.aa-ov-armer');
  /* LA GOMME NE PEINT PAS TANT QU'ELLE N'EST PAS ARMEE.
     Retour fondateur 08/09/2026 : « faire en sorte que la gomme ne s'active pas
     automatiquement mais plutot via un bouton — je viens de faire l'experience et cela m'a
     fait perdre du temps, modifier ma photo, et surtout 80 % des clients seront sur telephone
     donc cela sera problematique ».
     Il y avait DEUX defauts, et le second est le plus grave :
       1. le canvas effacait des le premier contact — un simple appui gommait la photo ;
       2. `touch-action:none` etait pose EN PERMANENCE : sur mobile, le doigt qui voulait
          FAIRE DEFILER la page gommait a la place. Le geste le plus naturel du telephone
          etait un piege, et rien ne le signalait.
     Corrige : un bouton arme la gomme, et `touch-action` ne passe a `none` qu'a ce moment-la.
     Desarmee, le doigt traverse et la page defile normalement. */
  if (eraseCv) {
    armerGomme = function (on) {
      st.gommeArmee = !!on;
      eraseCv.style.touchAction = st.gommeArmee ? 'none' : 'auto';
      eraseCv.style.cursor = st.gommeArmee ? 'crosshair' : 'default';
      eraseCv.classList.toggle('armee', st.gommeArmee);
      if (armerBtn) {
        armerBtn.textContent = st.gommeArmee
          ? T('gommeOff', '🧽 Gomme active')   // l'or du bouton et du cadre disent le reste ; le libelle long cassait la ligne a 360 px (15/09)
          : T('gommeOn', '🧽 Activer la gomme');
        armerBtn.classList.toggle('active', st.gommeArmee);
      }
    };
    armerGomme(false);
    if (armerBtn) armerBtn.addEventListener('click', function () { armerGomme(!st.gommeArmee); });
    var erasing = false;
    function erasePoint(e) {
      var r = eraseCv.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      if (x < 0 || y < 0 || x > 1 || y > 1) return;
      st.strokes[st.strokes.length - 1].push({ x: x, y: y, r: BRUSH });
      /* Feedback immediat local : on peint la couleur de la lune nue, pas du blanc. Peindre du
         blanc mentait deux fois — a l'ecran (la zone gommee devenait la plus claire de l'apercu)
         et sur la lampe (le blanc gagne le `lighten` du moteur). */
      var s = eraseCv.width;
      eraseCtx.save();
      eraseCtx.beginPath(); eraseCtx.arc(x * s, y * s, BRUSH * s, 0, Math.PI * 2); eraseCtx.clip();
      poserSol(eraseCtx, s);   // on decouvre EXACTEMENT le sol de l'apercu, pas une autre couleur
      eraseCtx.restore();
    }
    eraseCv.addEventListener('pointerdown', function (e) {
      if (!st.gommeArmee) return;   // desarmee : le doigt traverse, la page defile
      erasing = true;
      st.strokes.push([]);                       // nouveau groupe = 1 geste (annulable)
      if (st.strokes.length > 20) st.strokes.shift();
      st.touched.reglages = true;
      try { eraseCv.setPointerCapture(e.pointerId); } catch (err) {}
      erasePoint(e);
    });
    eraseCv.addEventListener('pointermove', function (e) { if (erasing) erasePoint(e); });
    var endE = function () { if (!erasing) return; erasing = false; rebuildRefSoon(); };
    eraseCv.addEventListener('pointerup', endE); eraseCv.addEventListener('pointercancel', endE);
  }
  /* Branche ICI et pas dans le bloc moteur plus haut : `ovs` n'est renseigne qu'apres le
     montage des overlays, un binding plus tot planterait au chargement. */
  if (cutBtn) cutBtn.addEventListener('click', function () {
    if (st.cutEnCours || st.cutAnim) return;
    if (!st.photoCut) lancerDetourage();   // premier clic : appel payant
    else appliquerCut(!st.cut);            // ensuite : bascule gratuite
  });
  syncCutBouton();
  if (undoBtn) undoBtn.addEventListener('click', function () {
    st.strokes.pop();
    drawErase(); rebuildRefSoon();
  });

  // ── Propriétés panier ──
  function ensureProp(name) {
    if (!form) return null;
    var el = form.querySelector('input[data-aa="' + name + '"]');
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[' + name + ']'; el.dataset.aa = name; form.appendChild(el); }
    return el;
  }
  /* CLE `_aa_moon` (17/09/2026) : le worker deploye ne reconnait une lampe QUE par cette propriete
     (server.mjs, bloc LAMPE LUNE). Le studio posait `_aa_design` : une commande reelle serait passee
     sans tag AA_MOON, sans note fournisseur, sans controle du lien photo — un skip silencieux. */
  function designJsonFor(o, uid) {
    return JSON.stringify({ v: 2, product: 'moon', crop: { cx: +o.crop.cx.toFixed(4), cy: +o.crop.cy.toFixed(4), zoom: +o.crop.zoom.toFixed(3), rot: Math.round(o.crop.rot) }, bright: +o.bright.toFixed(2), fond: o.fond, gomme: o.strokes.length, cut: !!o.cut, dessin: !!o.dessin, text: o.text || '', color: o.color, uid: uid || '' });
  }
  function designJson() { return designJsonFor(st, st.uid); }
  function syncProps() {
    if (!form) return;
    var set = function (n, v) {
      if (!v) { var old = form.querySelector('input[data-aa="' + n + '"]'); if (old) old.remove(); return; }
      var el = ensureProp(n); if (el) el.value = v;
    };
    set('_aa_moon', st.photo ? designJson() : '');
    set(T('kPerso', 'Personnalisation'), st.photo ? T('vPerso', '✓ Photo gravée dans la lune') : '');
    set(T('kTexte', 'Texte au dos'), st.text || '');
  }

  // ── CTA ──
  function relabelCTA() {
    var btn = addBtn(); if (!btn) return;
    var span = btn.querySelector('span');
    var v = curVariant();
    var avail = !v || v.available !== false;
    var setLbl = function (t) { if (span && span.textContent !== t) span.textContent = t; };
    if (!avail) { btn.disabled = true; setLbl(T('soldOut', 'Victime de son succès')); return; }
    if (packN > 1) {
      var ko = (typeof unavailableSlot === 'function') ? unavailableSlot() : -1;
      if (ko >= 0) { btn.disabled = true; setLbl(T('lampW', 'Lune ') + (ko + 1) + T('lampSoldOut', ' : victime de son succès')); return; }
    }
    if (!st.photo) { setLbl(T('addPhotoFirst', '📷 Ajoutez votre photo')); btn.disabled = false; return; }
    btn.disabled = false;
    if (packN > 1) {
      var done = readyCount();
      if (done >= packN) setLbl(T('addPack', 'Ajouter ') + packN + T('lampsToCart', ' lunes au panier') + ' · ' + fmtMoney(packTotals(packN).total));
      else setLbl(T('validateLamp', 'Valider cette lune (') + done + '/' + packN + ')');
      return;
    }
    setLbl(T('addCart', 'Ajouter au panier'));
  }

  // ── Référence → worker (_aa_photo) ──
  function refBlob() {
    return new Promise(function (r) {
      if (!st.ref) { r(null); return; }
      // JPEG = pas d'alpha : sans aplatissement, tout ce qui est transparent sortirait NOIR.
      M.flattenPrint(st.ref).toBlob(function (b) { r(b); }, 'image/jpeg', 0.92);
    });
  }
  function postPhoto(blob, maxAttempts, deadline) {
    var attempt = function (a) {
      var remaining = deadline - Date.now();
      if (remaining <= 1500 || a >= maxAttempts) return Promise.resolve(null);
      var ac = new AbortController();
      var base = (a === 0 && maxAttempts > 1) ? 12000 : 8000;
      var tt = setTimeout(function () { ac.abort(); }, Math.min(base, remaining));
      return fetch(CFG.workerUrl + '/api/moon-photo', { method: 'POST', headers: { 'Content-Type': 'application/octet-stream' }, body: blob, signal: ac.signal })
        .then(function (res) {
          if (res.status >= 400 && res.status < 500 && res.status !== 429) return null;
          return res.json().then(function (j) {
            var u = (j && (j.photoUrl || j.url)) || null;
            return u ? { url: u, durable: !!(j && j.durable) } : null;
          });
        })
        .catch(function () { return undefined; })
        .then(function (out) {
          clearTimeout(tt);
          if (out !== undefined) return out;
          return new Promise(function (r) { setTimeout(r, 600 * (a + 1)); }).then(function () { return attempt(a + 1); });
        });
    };
    return attempt(0);
  }
  /* GARDE-FOU (fait metier) — la commande n'existe QUE si la photo est arrivee au worker.
     Rend { ok, durable } : ok=false => on n'ajoute PAS au panier (le client ne paie pas dans le vide).
     durable=false => lien de repli non-CDN (< 24 h) : on laisse passer la vente mais on l'ETIQUETTE,
     le worker verifie ensuite la vivacite du lien et bloque la commande pour revue si besoin. */
  function attachPhotoRef(item) {
    var deadline = Date.now() + Math.min(45000, 12000 + 8000);
    return refBlob().then(function (blob) {
      if (!blob) return { ok: false, durable: false };
      return postPhoto(blob, 3, deadline).then(function (out) {
        if (!out || !out.url) return { ok: false, durable: false };
        item.properties['_aa_photo'] = out.url;
        if (!out.durable) item.properties['_aa_photo_durable'] = 'non';
        return { ok: true, durable: out.durable };
      });
    }).catch(function () { return { ok: false, durable: false }; });
  }
  function storeThumb(uid) {
    var t = M.thumb(st.ref, st.color);
    if (uid && t) { try { localStorage.setItem('aa_case_prev:' + uid, t); } catch (e) {} }
  }

  // ── MULTIPACK (17/09/2026, spec specs/PACK_LUNE_17-09.md) : N lunes, chacune sa photo ──
  /* Le selecteur ×1/×3/×5 = bloc pack NATIF du theme (.quantity-break[data-quantity]) ; on le LIT
     (delegue sur document : le theme RE-REND le bloc au changement de variante, lecon coques 23/07).
     L'etat du studio (st) est TOUJOURS celui de la lune courante ; les autres vivent dans `slots`. */
  var packN = 1, slots = [], slotIdx = 0;
  var trayEl = byId('aa-moon-slots'), slotsLblEl = byId('aa-moon-slots-lbl'), recapEl = byId('aa-moon-pack-recap');
  /* v2 (18/09) : une variante (taille + eclairage) PAR lune, et le VRAI prix du pack dans le bloc.
     TIERS = % de remise par palier, lus dans les reglages du bloc pack de la section (source de verite). */
  var TIERS = CFG.packTiers || { '3': 5, '5': 10 };
  function variantById(id) { for (var k in VMAP) { if (VMAP[k] && String(VMAP[k].id) === String(id)) return VMAP[k]; } return null; }
  function slotVariant(i) {   // lune courante = selecteurs du moment ; case vide = variante courante (ce que le client verrait sans rien toucher)
    var o = slots[i];
    if (i !== slotIdx && o && o.variantId) return variantById(o.variantId) || curVariant();
    return curVariant();
  }
  function sizeLabel(v) { return v && v.size ? String(v.size).toLowerCase() : ''; }
  function fmtMoney(cents) {   // format du theme : €114, €199,50 (« ,00 » retire), milliers « . »
    cents = Math.max(0, Math.round(cents));
    var e = Math.floor(cents / 100), c = cents % 100;
    return '€' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (c ? ',' + (c < 10 ? '0' + c : c) : '');
  }
  /* Regle Shopify MESUREE par l'API panier (18/09, 6 cas) : remise automatique en % = PAR UNITE,
     TRONQUEE au centime (39,99 x 5 % = 1,9995 -> 1,99), x quantite. Meme formule que le Liquid du bloc. */
  function packTotals(n) {
    var pct = +TIERS[String(n)] || 0, sum = 0, cmp = 0, disc = 0, sizes = [];
    for (var i = 0; i < n; i++) {
      var v = slotVariant(i); if (!v) continue;
      sum += v.price; cmp += (v.compareAt || v.price); disc += Math.floor(v.price * pct / 100); sizes.push(sizeLabel(v));
    }
    return { pct: pct, sum: sum, compare: cmp, discount: disc, total: sum - disc, sizes: sizes };
  }
  function unavailableSlot() {   // premiere lune validee dont la variante n'est plus vendable (-1 sinon)
    for (var i = 0; i < packN; i++) { var o = slots[i]; if (!o || !o.validated || !o.variantId || i === slotIdx) continue; var v = variantById(o.variantId); if (v && v.available === false) return i; }
    return -1;
  }
  function applyVariant(o) {   // remet les selecteurs de la lune ; le theme fait le reste (URL, prix, input id, re-dessin du bloc -> observateur)
    if (!o || !o.variantId) return;
    var cur = curVariant(); if (cur && String(cur.id) === String(o.variantId)) return;
    var v = variantById(o.variantId); if (!v) return;
    var sels = document.querySelectorAll('variant-selects select'), last = null;
    if (!sels.length) {
      var idIn = form && form.querySelector('input[name="id"]');
      if (idIn) { idIn.value = v.id; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    [].forEach.call(sels, function (sel, k) {
      var want = k === 0 ? v.size : v.mode; if (want == null) return;
      for (var j = 0; j < sel.options.length; j++) if (sel.options[j].value === want) { sel.value = want; last = sel; break; }
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function renderRecap() {   // « 3 lunes · 18 cm, 20 cm, 8 cm · €228 au lieu de €239,97 » — memes chiffres que le bloc
    if (!recapEl) return;
    if (packN <= 1) { recapEl.style.display = 'none'; recapEl.innerHTML = ''; return; }
    var t = packTotals(packN); if (!t.sum) { recapEl.style.display = 'none'; return; }
    recapEl.style.display = '';
    recapEl.innerHTML = '<b>' + packN + T('lampsW', ' lunes') + '</b> · ' + t.sizes.join(', ') + ' · <b>' + fmtMoney(t.total) + '</b>'
      + (t.compare > t.total ? ' ' + T('insteadOf', 'au lieu de') + ' <s>' + fmtMoney(t.compare) + '</s>' : '');
  }
  function syncPackPrices() {   // reecrit les prix des paliers 3/5 du bloc (barre + remise) puis laisse le theme propager au prix du haut
    var host = document.querySelector('quantity-breaks');
    [].forEach.call(document.querySelectorAll('.quantity-break[data-quantity]'), function (tier) {
      var n = parseInt(tier.getAttribute('data-quantity'), 10); if (!(n === 3 || n === 5)) return;
      var t = packTotals(n), pc = tier.querySelector('.quantity-break_price-container'); if (!pc || !t.sum) return;
      var cmpEl = pc.querySelector('.quantity-break_price-container_compare-at-price'), prEl = pc.querySelector('.quantity-break_price-container_price');
      if (!prEl) return;
      var total = fmtMoney(t.total), cmp = fmtMoney(t.compare);
      if (t.compare !== t.total) {
        if (!cmpEl) { cmpEl = document.createElement('p'); cmpEl.className = 'quantity-break_price-container_compare-at-price'; pc.insertBefore(cmpEl, prEl); }
        if (cmpEl.textContent !== cmp) cmpEl.textContent = cmp;
      } else if (cmpEl) cmpEl.parentNode.removeChild(cmpEl);
      if (prEl.textContent !== total) prEl.textContent = total;
    });
    if (host && typeof host.updateMainPrice === 'function') { try { host.updateMainPrice(); } catch (e) {} }
    renderRecap();
  }
  function packVariantChanged() {   // taille/eclairage changes sur la lune courante : elle prend la variante du moment (validation conservee)
    if (packN > 1) { var v = curVariant(); if (v) { if (!slots[slotIdx]) slots[slotIdx] = { validated: false }; slots[slotIdx].variantId = v.id; } }
    if (packN > 1) renderTray();
    syncPackPrices();
  }
  function readPackN() {
    var el = document.querySelector('.selected-quantity-break[data-quantity]');
    var n = el ? parseInt(el.getAttribute('data-quantity'), 10) : 1;
    return (n === 3 || n === 5) ? n : 1;
  }
  function snapshotState(validated) {
    var cv = curVariant();
    return {
      variantId: cv ? cv.id : null,
      photoOrig: st.photoOrig, photoCut: st.photoCut, cut: !!st.cut,
      photoDessin: st.photoDessin, dessin: !!st.dessin, dessinRelances: st.dessinRelances,
      crop: { cx: st.crop.cx, cy: st.crop.cy, zoom: st.crop.zoom, rot: st.crop.rot },
      bright: st.bright, fond: st.fond, fondChoisi: !!st.fondChoisi, strokes: st.strokes.slice(), text: st.text || '', color: st.color,
      touched: { cadrage: !!st.touched.cadrage, reglages: !!st.touched.reglages },
      thumb: st.ref ? M.thumb(st.ref, st.color) : null, validated: !!validated
    };
  }
  function slotRef(o) {   // reference 1200² d'une lune NON courante, sans toucher l'ecran
    var img = (o.dessin && o.photoDessin) ? o.photoDessin : ((o.cut && o.photoCut) ? o.photoCut : o.photoOrig);
    return img ? M.renderReference(img, o.crop, o.bright, { fond: o.fond, strokes: o.strokes, trait: o.dessin }) : null;
  }
  function saveCurrent(validate) {
    if (packN <= 1) return;
    if (!st.photo) { var cv0 = curVariant(); slots[slotIdx] = cv0 ? { variantId: cv0.id, validated: false } : null; return; }   // case vide : sa taille est gardee
    var keep = slots[slotIdx] && slots[slotIdx].validated;
    slots[slotIdx] = snapshotState(validate === true || (validate !== false && keep));
  }
  function applyState(o) {
    st.photoOrig = o.photoOrig; st.photoCut = o.photoCut; st.cut = o.cut;
    st.photoDessin = o.photoDessin; st.dessin = o.dessin; st.dessinRelances = o.dessinRelances;
    st.photo = imageCourante(o.dessin, o.cut);
    st.crop = { cx: o.crop.cx, cy: o.crop.cy, zoom: o.crop.zoom, rot: o.crop.rot };
    st.bright = o.bright; st.fond = o.fond; st.fondChoisi = !!o.fondChoisi; st.strokes = o.strokes.slice(); st.text = o.text || '';
    st.touched = { cadrage: o.touched.cadrage, reglages: o.touched.reglages };
    st.cutJeton++;
    if (textInput) textInput.value = st.text;
    st.face = 'front';
    setColor(o.color || st.color);
    syncFondButtons(); syncCutBouton(); syncDessinBouton();
    rebuildRef();
    if (upZone) upZone.classList.add('has-photo');
    if (upDone) upDone.style.display = '';
    setStatus('');
    applyVariant(o);
  }
  function clearState() {
    st.photoOrig = null; st.photo = null; st.photoCut = null; st.cut = false;
    st.photoDessin = null; st.dessin = false; st.dessinRelances = 0;
    st.crop = { cx: 0.5, cy: 0.5, zoom: 1, rot: 0 }; st.bright = 1.0; st.fond = 'ovale'; st.fondChoisi = false; st.strokes = []; st.text = '';
    st.touched = { cadrage: false, reglages: false };
    st.cutJeton++; st.face = 'front';
    if (textInput) textInput.value = '';
    syncFondButtons(); syncCutBouton(); syncDessinBouton();
    rebuildRef();   // sans photo, rebuildRef s'arrete tot : on remet nous-memes jauge, badge, icones, CTA
    syncGauge(); syncFrameActions(); relabelCTA();
    if (upZone) upZone.classList.remove('has-photo');
    if (upDone) upDone.style.display = 'none';
    setStatus('');
    if (st.gl) st.gl.spinTo(0);
  }
  function slotDone(i) { return !!(slots[i] && slots[i].validated && (i !== slotIdx || st.photo)); }
  function readyCount() { var n = 0; for (var i = 0; i < packN; i++) if (slotDone(i)) n++; return n; }
  function nextIncomplete() { for (var i = 0; i < packN; i++) { if (i === slotIdx) continue; if (!slotDone(i)) return i; } return -1; }
  function renderTray() {
    if (!trayEl) return;
    if (packN <= 1) { trayEl.innerHTML = ''; trayEl.style.display = 'none'; if (slotsLblEl) slotsLblEl.style.display = 'none'; return; }
    trayEl.style.display = ''; if (slotsLblEl) slotsLblEl.style.display = 'block'; trayEl.innerHTML = '';
    for (var i = 0; i < packN; i++) {
      var done = slotDone(i);
      var thumb = (i === slotIdx && st.ref) ? M.thumb(st.ref, st.color) : ((slots[i] && slots[i].thumb) || null);
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'aa-slot' + (i === slotIdx ? ' current' : '') + (done ? ' done' : '');
      var sv = slotVariant(i), sz = sizeLabel(sv);
      b.innerHTML = (thumb ? '<img src="' + thumb + '" alt="">' : '<span class="aa-slot-n">' + (i + 1) + '</span>') + '<em>' + T('lampW', 'Lune ') + (i + 1) + (done ? ' ✓' : '') + '</em>' + (sz ? '<small>' + sz + '</small>' : '');
      if (sv && sv.mode) b.title = (sv.size || '') + ' · ' + sv.mode;
      b.addEventListener('click', (function (k) { return function () { gotoSlot(k); }; })(i));
      trayEl.appendChild(b);
    }
  }
  function loadSlot(i) {
    slotIdx = i; closeAll();
    if (slots[i] && slots[i].photoOrig) applyState(slots[i]); else { clearState(); if (slots[i] && slots[i].variantId) applyVariant(slots[i]); }
    renderTray(); relabelCTA(); syncPackPrices();
  }
  function gotoSlot(i) { if (i === slotIdx) return; saveCurrent(); loadSlot(i); }
  function setPack(n) {
    n = (n === 3 || n === 5) ? n : 1;
    if (n === packN) { renderTray(); relabelCTA(); syncPackPrices(); return; }
    saveCurrent();
    var shrink = n < packN, cur = slots[slotIdx], i;
    if (n === 1) {
      /* retour ×1 : on garde la lune courante si elle a une photo, sinon la premiere qui en a une
         (le client qui vient de valider Lune 1 et hesite sur Lune 2 ne perd pas son travail) */
      var keep = (cur && cur.photoOrig) ? cur : null;
      for (i = 0; !keep && i < packN; i++) if (slots[i] && slots[i].photoOrig) keep = slots[i];
      slots[0] = keep; slotIdx = 0;
    } else if (slotIdx >= n) {
      // ×5 → ×3 depuis Lune 4/5 : la courante prend la premiere case libre, sinon la derniere
      var dest = -1;
      for (i = 0; i < n; i++) if (!(slots[i] && slots[i].photoOrig)) { dest = i; break; }
      if (dest < 0) dest = n - 1;
      if (cur && cur.photoOrig) slots[dest] = cur;
      slotIdx = dest;
    }
    packN = n; slots.length = n;
    if (shrink) loadSlot(slotIdx); else { renderTray(); relabelCTA(); syncPackPrices(); }
  }
  function packPhotoChanged() { if (packN > 1 && slots[slotIdx]) { slots[slotIdx].validated = false; renderTray(); } }
  var _trayT = 0;
  function refreshTraySoon() { if (packN <= 1) return; clearTimeout(_trayT); _trayT = setTimeout(renderTray, 400); }
  /* Ajout ×N : pour CHAQUE lune, reference 1200² regeneree depuis son etat → worker (_aa_photo).
     GARDE-FOU ×N : une seule photo qui n'arrive pas = RIEN n'est ajoute (sinon le fournisseur
     recevrait un pack avec un trou, apres encaissement). Les envois sont sequentiels : un telephone
     en 4G supporte mal 5 POST de 300 Ko en parallele. */
  function runPackAdd() {
    var ko = unavailableSlot();
    if (ko >= 0) { setStatus(T('lampW', 'Lune ') + (ko + 1) + T('lampSoldOutLong', ' : cette taille n\u2019est plus disponible \u2014 choisissez-en une autre.'), true); relabelCTA(); return Promise.resolve(); }
    _adding = true;
    var btn = addBtn(), span = btn && btn.querySelector('span');
    var v = curVariant(), idInput = form && form.querySelector('input[name="id"]');
    var vid = v ? v.id : (idInput && parseInt(idInput.value, 10)) || null;
    var batch = 'aam' + Date.now().toString(36);
    var items = [], i = 0;
    var progress = function () { if (btn) { btn.disabled = true; if (span) span.textContent = T('adding', 'Ajout en cours…') + ' (' + (i + 1) + '/' + packN + ')'; } };
    var next = function () {
      if (i >= packN) {
        items.forEach(function (it) { var t = it._thumb; if (t) { try { localStorage.setItem('aa_case_prev:' + it.properties['_AA_preview'], t); } catch (e) {} } delete it._thumb; });
        window['__aaMoonItems_' + SID] = items;
        return addToCart(items);
      }
      progress();
      var o = slots[i]; if (!o) { i++; return next(); }
      var ref = slotRef(o); if (!ref) { i++; return next(); }
      var uid = batch + '-' + i;
      var props = { '_aa_moon': designJsonFor(o, uid), '_AA_preview': uid, '_aa_pack': batch };
      props[T('kPerso', 'Personnalisation')] = T('vPerso', '✓ Photo gravée dans la lune') + ' · ' + T('lampW', 'Lune ') + (i + 1);
      if (o.text) props[T('kTexte', 'Texte au dos')] = o.text;
      var sv = (o.variantId && variantById(o.variantId)) || null;   // v2 : la variante de CETTE lune
      var item = { id: sv ? sv.id : vid, quantity: 1, properties: props, _thumb: M.thumb(ref, o.color) };
      var deadline = Date.now() + 20000;
      return new Promise(function (r) { M.flattenPrint(ref).toBlob(function (b) { r(b); }, 'image/jpeg', 0.92); })
        .then(function (blob) { return blob ? postPhoto(blob, 3, deadline) : null; })
        .then(function (out) {
          if (!out || !out.url) throw new Error('photo ' + (i + 1));
          props['_aa_photo'] = out.url; if (!out.durable) props['_aa_photo_durable'] = 'non';
          items.push(item); i++; return next();
        });
    };
    return next()
      .catch(function () {
        setStatus(T('photoKO', '⚠️ Votre photo n\u2019a pas pu \u00eatre envoy\u00e9e. V\u00e9rifiez votre connexion et retouchez \u00ab Ajouter au panier \u00bb.'), true);
      })
      .then(function () { _adding = false; relabelCTA(); });
  }
  // Lecture du bloc pack : delegue, + on rejoue la selection visuelle si le theme a perdu ses ecouteurs (coques 23/07)
  function syncTierVisual(qb) {
    try {
      var host = qb.closest('quantity-breaks');
      if (host && typeof host.selectQuantity === 'function') { host.selectQuantity(qb); return; }
      var scope = host || document;
      [].forEach.call(scope.querySelectorAll('.quantity-break'), function (t) { t.classList.remove('selected-quantity-break'); });
      if (!qb.classList.contains('quantity-break--disabled')) qb.classList.add('selected-quantity-break');
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var qb = e.target && e.target.closest && e.target.closest('.quantity-break[data-quantity]');
    if (qb) { syncTierVisual(qb); setPack(parseInt(qb.getAttribute('data-quantity'), 10)); }
  });
  setTimeout(function () { setPack(readPackN()); }, 0);
  /* Le theme (quantity-breaks.js) RE-TELECHARGE la section et remplace l'innerHTML du bloc a CHAQUE
     changement de variante : icones perdues, palier remis a ×1, prix Liquid. On regagne la main ici. */
  function onPackBlockRedraw() {
    injectPackIcons();
    if (packN > 1) {
      var qb = document.querySelector('.quantity-break[data-quantity="' + packN + '"]');
      if (qb && !qb.classList.contains('selected-quantity-break')) {
        syncTierVisual(qb);
        var host = qb.closest('quantity-breaks');
        if (host && typeof host.updateFormInputs === 'function') { try { host.updateFormInputs(qb); } catch (e) {} }
      }
    }
    syncPackPrices(); relabelCTA();
  }
  var _qbT = 0;
  (function watchPackBlock() {
    var host = document.querySelector('quantity-breaks'); if (!host || !window.MutationObserver) return;
    new MutationObserver(function () { clearTimeout(_qbT); _qbT = setTimeout(onPackBlockRedraw, 30); }).observe(host, { childList: true });
  })();
  /* variant-selects (Dawn) reecrit le texte du bouton apres SON fetch (« Ajouter au panier » meme sans photo) :
     on re-libelle des qu'il bouge — relabelCTA n'ecrit que si different, donc pas de boucle. */
  (function watchAddBtn() {
    var btn = addBtn(); if (!btn || !window.MutationObserver) return;
    var busy = false;
    new MutationObserver(function () {
      if (busy || _adding) return;
      busy = true; setTimeout(function () { busy = false; if (!_adding) relabelCTA(); }, 0);
    }).observe(btn, { childList: true, characterData: true, subtree: true });
  })();
  window['__aaMoonPack_' + SID] = function () {
    var cv = curVariant();
    return { packN: packN, slotIdx: slotIdx, ready: readyCount(), current: { photo: !!st.photo, text: st.text, dessin: !!st.dessin, color: st.color, variant: cv && cv.id, size: cv && cv.size },
      totals: packN > 1 ? packTotals(packN) : null,
      slots: slots.map(function (o, i) { var sv = slotVariant(i); return o ? { photo: !!o.photoOrig, text: o.text, dessin: o.dessin, color: o.color, validated: o.validated, thumb: !!o.thumb, variantId: o.variantId, size: sv && sv.size } : null; }) };
  };

  // ── Add-to-cart (délégation capture — bouton principal + sticky) ──
  var _adding = false;
  function qty() {
    var q = form && (form.elements['quantity'] || form.querySelector('input[name="quantity"]'));
    var n = q ? parseInt(q.value, 10) : 1;
    return (n >= 1 && n <= 20) ? n : 1;
  }
  function buildItem() {
    var v = curVariant();
    var idInput = form && form.querySelector('input[name="id"]');
    var vid = v ? v.id : (idInput && parseInt(idInput.value, 10)) || null;
    st.uid = 'aam' + Date.now().toString(36);
    var props = {
      '_aa_moon': designJson(),
      '_AA_preview': st.uid,
      [T('kPerso', 'Personnalisation')]: T('vPerso', '✓ Photo gravée dans la lune')
    };
    if (st.text) props[T('kTexte', 'Texte au dos')] = st.text;
    return { id: vid, quantity: qty(), properties: props };
  }
  function addToCart(item) {
    var items = Array.isArray(item) ? item : [item];
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: it.properties }; }), sections_url: window.location.pathname };
    if (cart && cart.getSectionsToRender) { try { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {} }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { alert(res.description || 'Ajout au panier impossible.'); return; }
        window['__aaMoonAdded_' + SID] = true;
        if (cart && cart.renderContents) { if (cart.classList) cart.classList.remove('is-empty'); cart.renderContents(res); }
        else { window.location = (window.routes && window.routes.cart_url) || '/cart'; }
      })
      .catch(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; });
  }
  function onAddClick() {
    if (_adding) return;
    if (!st.photo) {
      var target = upZone || byId('aa-moon-controls');
      if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); target.classList.add('nudge'); setTimeout(function () { target.classList.remove('nudge'); }, 900); }
      setStatus(T('needPhoto', '📷 Ajoutez votre photo pour créer votre lune'), true);
      return;
    }
    if (packN > 1) {
      if (readyCount() >= packN) { saveCurrent(); runPackAdd(); return; }
      saveCurrent(true);   // « Valider cette lune » : la courante est validee, on passe a la prochaine vide
      var nxt = nextIncomplete();
      if (nxt >= 0) loadSlot(nxt); else { renderTray(); relabelCTA(); }
      return;
    }
    _adding = true;
    var btn = addBtn(), span = btn && btn.querySelector('span');
    if (btn) { btn.disabled = true; if (span) span.textContent = T('adding', 'Ajout en cours…'); }
    clearTimeout(_refT); rebuildRef(); // FLUSH : la référence part TOUJOURS avec le dernier réglage
    var item = buildItem();
    window['__aaMoonItem_' + SID] = item;
    attachPhotoRef(item)
      .then(function (r) {
        /* GARDE-FOU : pas d'URL photo = pas de commande. Sans ce lien, le fournisseur n'a RIEN
           a graver et la commande arriverait bloquee cote worker, apres encaissement. */
        if (!r || !r.ok) {
          setStatus(T('photoKO', '⚠️ Votre photo n\u2019a pas pu \u00eatre envoy\u00e9e. V\u00e9rifiez votre connexion et retouchez \u00ab Ajouter au panier \u00bb.'), true);
          return;
        }
        storeThumb(item.properties['_AA_preview']);
        return addToCart(item);
      })
      .finally(function () { _adding = false; relabelCTA(); });
  }
  (function hookAdd() {
    if (!form) return;
    form.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[name="add"], .product-form__submit');
      if (b) { e.preventDefault(); e.stopImmediatePropagation(); onAddClick(); }
    }, true);
    /* Un submit NATIF (touche Entree dans un champ) est transforme en ajout au panier par
       <product-form> (Dawn) — ce qui contournait entierement le garde-fou et creait une commande
       sans _aa_photo. Ecoute en CAPTURE sur document : le formulaire est la CIBLE de l'evenement,
       donc un ecouteur pose sur lui-meme partirait dans l'ordre d'enregistrement (Dawn s'enregistre
       avant nous) ; sur un ancetre, la capture passe forcement en premier.

       On ne se fie PAS a l'identite du formulaire : verifie le 05/09/2026, la fiche en porte DEUX
       qui postent vers /cart/add — celui du studio, et celui de Shop Pay « paiement en plusieurs
       fois » genere par Shopify. Ce dernier n'a pas de bouton visible, mais soumis il ajoute la
       lampe SANS photo. Le critere est donc un FAIT METIER : la variante soumise est-elle une
       variante de CETTE lampe ? Un quick-add de recommandation pour un autre produit passe. */
    function estVarianteLune(valeur) {
      var n = parseInt(valeur, 10);
      if (!n) return false;
      var m = CFG.variantMap || {};
      for (var k in m) { if (m[k] && m[k].id === n) return true; }
      return false;
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      if (f !== form) {
        if (String(f.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
        var champ = f.querySelector('input[name="id"]');
        if (!champ || !estVarianteLune(champ.value)) return;
      }
      e.preventDefault(); e.stopImmediatePropagation();
      onAddClick();
    }, true);
  })();

  // ── 📸 Partage / ⬇️ téléchargement (filigrané) ──
  function exportCard(cb) {
    var snap = null;
    if (st.mode === '3d' && st.gl) snap = st.gl.snapshot();
    var srcP = snap ? M.loadImage(snap) : Promise.resolve(null);
    srcP.then(function (img) {
      var s = 900, c = document.createElement('canvas'); c.width = s; c.height = s + Math.round(s * 0.13);
      var x = c.getContext('2d');
      x.fillStyle = '#10131e'; x.fillRect(0, 0, c.width, c.height);
      if (img) x.drawImage(img, 0, 0, s, s);
      else M.drawFallback(x, s, s, { albedo: st.albedo, ref: st.ref, lit: true, color: st.color, trait: st.dessin, face: 'front' });
      // filigrane discret (l'aperçu partagé n'est jamais le fichier d'impression)
      x.save(); x.globalAlpha = 0.18; x.translate(s / 2, s / 2); x.rotate(-0.5);
      x.fillStyle = '#ffffff'; x.font = '700 ' + Math.round(s * 0.06) + 'px Georgia'; x.textAlign = 'center';
      x.fillText('ami-amour.fr', 0, 0); x.restore();
      x.textAlign = 'center'; x.fillStyle = '#f3d9a4'; x.font = '700 ' + Math.round(s * 0.05) + 'px Georgia';
      x.fillText(T('shareLine', 'Ma lune, notre souvenir'), s / 2, s + Math.round(s * 0.055));
      x.fillStyle = '#b7a274'; x.font = '600 ' + Math.round(s * 0.034) + 'px Georgia';
      x.fillText('ami-amour.fr', s / 2, s + Math.round(s * 0.1));
      c.toBlob(function (blob) { if (blob) cb(blob); }, 'image/png');
    });
  }
  var frameActions = stage.querySelector('.aa-moon-frame-actions');
  var shareBtn = stage.querySelector('.aa-mfa[data-act="share"]');
  /* `navigator.canShare({files})` sans fichier reel est le seul test possible avant l'export :
     on lui donne un fichier vide du bon type, ce qui suffit a savoir si l'API existe et
     accepte les images. Faux (Chrome desktop, Firefox) → on n'affiche pas le bouton. */
  (function initShare() {
    if (!shareBtn) return;
    var ok = false;
    try {
      ok = !!(navigator.canShare && navigator.share &&
              navigator.canShare({ files: [new File([new Blob([], { type: 'image/png' })], 'x.png', { type: 'image/png' })] }));
    } catch (e) { ok = false; }
    shareBtn.hidden = !ok;
  })();
  function syncFrameActions() { if (frameActions) frameActions.hidden = !st.photo; }
  syncFrameActions();

  /* Bloc « Quantité » natif du thème (×1/×3/×5) : il n'affiche qu'une image produit → on la remplace
     par palier (lune vide ×1, ×3, ×5 — retour fondateur 17/09 : pas de dessin, pour ne pas charger la
     fiche). Meme mecanique que les coques (aa-case-studio.js, GC22 point 1). Le bloc se RE-REND au
     clic sur un palier (lecon coques 23/07) → on re-injecte apres chaque clic. */
  function injectPackIcons() {
    var map = CFG.packIcons || null; if (!map) return;
    [].forEach.call(document.querySelectorAll('.quantity-break[data-quantity]'), function (tier) {
      var url = map[String(tier.getAttribute('data-quantity'))]; if (!url) return;
      var img = tier.querySelector('.quantity-break_image-container img'); if (!img || img.getAttribute('src') === url) return;
      img.removeAttribute('srcset'); img.removeAttribute('width'); img.removeAttribute('height'); img.setAttribute('src', url);
    });
  }
  injectPackIcons();
  setTimeout(injectPackIcons, 300);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quantity-break[data-quantity]')) setTimeout(injectPackIcons, 60);
  });

  [].forEach.call(stage.querySelectorAll('.aa-mfa'), function (b) {
    b.addEventListener('click', function () {
      try {
        exportCard(function (blob) {
          var file = new File([blob], 'ma-lune.png', { type: 'image/png' });
          if (b.dataset.act === 'share' && navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file], title: T('shareTitle', 'Ma lampe lune personnalisée'), text: T('shareText', 'Créez la vôtre sur ami-amour.fr') }).catch(function () {});
          } else {
            var u = URL.createObjectURL(blob); var a = document.createElement('a'); a.href = u; a.download = file.name; a.click(); URL.revokeObjectURL(u);
          }
        });
      } catch (e) { console.error('[aa-moon] export', e); }
    });
  });

  // ── MOBILE sticky/park (pattern coques) ──
  function _unparkMw() {
    if (!mwEl) return;
    mwEl._parked = false;
    if (_mwPh && _mwPh.parentNode) _mwPh.parentNode.removeChild(_mwPh);
    mwEl.style.setProperty('position', 'sticky', 'important');
    mwEl.style.setProperty('top', '0px', 'important');
    mwEl.style.removeProperty('left'); mwEl.style.removeProperty('right');
  }
  function updateMobileSticky() {
    // GC28 v2 r7 (retour fondateur) : la lune ne suit PLUS au scroll sur mobile — la carte quasi plein
    // écran en sticky rendait la page « figée » (CTA/description défilaient invisibles derrière).
    // Flux normal partout ; le sticky desktop reste géré par le CSS (colonne 2 col, aucun conflit).
    if (mwEl) { mwEl.style.removeProperty('position'); mwEl.style.removeProperty('top'); }
  }
  var _stickTick = false;
  window.addEventListener('scroll', function () { if (_stickTick) return; _stickTick = true; requestAnimationFrame(function () { _stickTick = false; updateMobileSticky(); }); }, { passive: true });
  window.addEventListener('resize', function () { updateMobileSticky(); if (st.mode === '2d') paint2D(); });
  setTimeout(updateMobileSticky, 150);
  setTimeout(onVariantChange, 200);
  relabelCTA(); syncProps(); syncGauge();

  // ── Barre sticky add-to-cart du thème : visible SEULEMENT une fois le CTA principal DÉPASSÉ
  //    (sorti de l'écran par le haut) — avant ça elle dérange la personnalisation (retour fondateur 7)
  // ── Barre sticky ATC (retour fondateur 10) : apparaît SEULEMENT une fois le CTA initial dépassé.
  //    Pilotée par LA CLASSE DU THÈME (showStickyAddtocart) — jamais par style inline (leçon r9 :
  //    un display:none !important avait tué le CTA mobile). FAIL-OPEN : mesure douteuse → on ne touche
  //    à rien (comportement natif). MutationObserver + scroll = hors pipeline rAF (onglets gelés ok).
  (function gateStickyBar() {
    var bar = document.getElementById('stickyAddtocartContainer');
    if (!bar) return;
    var CLS = 'showStickyAddtocart';
    function passedRef() {
      // retour fondateur 11 : la référence = LE STUDIO (plus le CTA) — barre visible dès que la carte
      // a disparu en haut au scroll ; tant que la lune est à l'écran, rien ne gêne la perso
      if (!stage) return null;
      var r = stage.getBoundingClientRect();
      if (!r.height) return null;
      return r.bottom < 0; // studio sorti par le HAUT = dépassé
    }
    var syncing = false;
    function sync() {
      if (syncing) return;
      syncing = true;
      try {
        var p = passedRef();
        if (p !== null) {
          if (p && !bar.classList.contains(CLS)) bar.classList.add(CLS);
          else if (!p && bar.classList.contains(CLS)) bar.classList.remove(CLS);
        }
      } finally { syncing = false; }
    }
    try { new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    var t = 0;
    window.addEventListener('scroll', function () { if (t) return; t = setTimeout(function () { t = 0; sync(); }, 80); }, { passive: true });
    if ('IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(sync, { threshold: 0 });
        io.observe(stage);
        var c0 = addBtn(); if (c0) io.observe(c0);
      } catch (e) {}
    }
    sync();
  })();

  // ── Preuves ──
  window['__aaMoonReady_' + SID] = function () {
    return {
      mode: st.mode, hasPhoto: !!st.photo, hasRef: !!st.ref, lit: st.lit, color: st.color,
      text: st.text, fond: st.fond, gomme: st.strokes.length, rot: st.crop.rot,
      albedo: !!st.albedo, variant: (curVariant() || {}), uid: st.uid,
      canvas: st.mode === '3d' && st.gl ? 'gl' : (cv2.width + 'x' + cv2.height)
    };
  };
})();
